import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vShow as _vShow, isRef as _isRef, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, Fragment as _Fragment, renderList as _renderList, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/shopcart/upload_d2c.png'
import _imports_1 from '@/assets/image/shopcart/un_upload_d2c.png'
import _imports_2 from '@/assets/image/shopcart/upload_b2b.png'
import _imports_3 from '@/assets/image/shopcart/un_upload_b2b.png'
import _imports_4 from '@/assets/image/product-red-open.png'
import _imports_5 from '@/assets/image/product-red-close.png'
import _imports_6 from '@/assets/image/product-blue-open.png'
import _imports_7 from '@/assets/image/product-blue-close.png'
import _imports_8 from '@/assets/image/icon/question.png'


const _withScopeId = n => (_pushScopeId("data-v-67a073d1"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "flex-ter",
  style: {"flex":"1"}
}
const _hoisted_2 = {
  key: 0,
  class: "wareHouseType"
}
const _hoisted_3 = { class: "tabs" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/CN.png",
  alt: ""
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/JP.png",
  alt: ""
}, null, -1))
const _hoisted_6 = { class: "tableBox" }
const _hoisted_7 = {
  class: "setting flex-ter-bwn stock-setting",
  style: {"margin-bottom":"32px"}
}
const _hoisted_8 = { class: "flex-ter" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  class: "flex-ter",
  style: {"padding":"20px 0","justify-content":"space-between"}
}
const _hoisted_11 = {
  class: "flex-ter",
  style: {"gap":"12px"}
}
const _hoisted_12 = {
  class: "flex-ter",
  style: {"gap":"12px"}
}
const _hoisted_13 = { style: {"padding":"20px 0"} }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = {
  key: 1,
  class: "createTips"
}
const _hoisted_16 = { class: "upload-file-modal-content" }
const _hoisted_17 = { class: "upload-part" }
const _hoisted_18 = {
  key: 0,
  src: _imports_0,
  alt: "",
  class: "upload-part-img"
}
const _hoisted_19 = {
  key: 1,
  src: _imports_1,
  alt: "",
  class: "upload-part-img"
}
const _hoisted_20 = {
  key: 0,
  src: _imports_2,
  alt: "",
  class: "upload-part-img"
}
const _hoisted_21 = {
  key: 1,
  src: _imports_3,
  alt: "",
  class: "upload-part-img"
}
const _hoisted_22 = { class: "upload-part-text" }
const _hoisted_23 = { class: "download-template" }
const _hoisted_24 = ["href"]
const _hoisted_25 = { class: "download-tip" }
const _hoisted_26 = {
  key: 4,
  style: {"margin-left":"10px","font-size":"12px"}
}
const _hoisted_27 = { class: "flex-ter" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = ["src"]
const _hoisted_30 = { class: "flex-center" }
const _hoisted_31 = { class: "columns-search-style" }
const _hoisted_32 = {
  key: 1,
  class: "border-style"
}
const _hoisted_33 = { class: "border-left-export" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "download-icon",
  alt: "",
  src: "https://static-s.theckb.com/BusinessMarket/icon/download-icon@3.x.png"
}, null, -1))
const _hoisted_35 = { class: "product-table" }
const _hoisted_36 = {
  key: 0,
  style: {"cursor":"pointer"},
  class: "product-img"
}
const _hoisted_37 = {
  key: 1,
  class: "product-img"
}
const _hoisted_38 = { class: "flex-ter" }
const _hoisted_39 = { class: "product-img" }
const _hoisted_40 = { style: {"width":"120px","text-align":"left"} }
const _hoisted_41 = { key: 0 }
const _hoisted_42 = { class: "show-two-line" }
const _hoisted_43 = { class: "show-two-line" }
const _hoisted_44 = /*#__PURE__*/_createTextVNode("予約販売")
const _hoisted_45 = { class: "platform-inventory-style" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "expand-icon",
  alt: "",
  src: "https://static-s.theckb.com/BusinessMarket/Client/expandIconStock.png"
}, null, -1))
const _hoisted_47 = { class: "show-one-line" }
const _hoisted_48 = {
  key: 0,
  class: "show-one-line"
}
const _hoisted_49 = { class: "show-one-line" }
const _hoisted_50 = { class: "product-sku-word" }
const _hoisted_51 = { class: "product-sku-word show-one-line" }
const _hoisted_52 = { class: "product-sku-word" }
const _hoisted_53 = { class: "flex just-center" }
const _hoisted_54 = { class: "show-one-line" }
const _hoisted_55 = { class: "flex just-center" }
const _hoisted_56 = { class: "show-one-line" }
const _hoisted_57 = {
  key: 1,
  class: "flex just-center"
}
const _hoisted_58 = { class: "show-one-line" }
const _hoisted_59 = { class: "flexter" }
const _hoisted_60 = { key: 0 }
const _hoisted_61 = { key: 1 }
const _hoisted_62 = { key: 0 }
const _hoisted_63 = { key: 1 }
const _hoisted_64 = { key: 2 }
const _hoisted_65 = { class: "commonProduct flex-ter" }
const _hoisted_66 = { class: "amazonProduct flex-ter" }
const _hoisted_67 = { style: {"max-width":"200px","font-size":"14px"} }
const _hoisted_68 = { class: "pending-storage-style platform-inventory-style" }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "expand-icon close-icon",
  alt: "",
  src: "https://static-s.theckb.com/BusinessMarket/Client/expandIconStock.png"
}, null, -1))
const _hoisted_70 = {
  class: "flex-ter-bwn",
  style: {"min-width":"200px","margin":"0 0 10px 0"}
}
const _hoisted_71 = { style: {"width":"150px"} }
const _hoisted_72 = { class: "flex-ter-bwn" }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "不良·異常対応中", -1))
const _hoisted_74 = { key: 1 }
const _hoisted_75 = { class: "platform-inventory-style" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "expand-icon",
  alt: "",
  src: "https://static-s.theckb.com/BusinessMarket/Client/expandIconStock.png"
}, null, -1))
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "expand-icon close-icon",
  alt: "",
  src: "https://static-s.theckb.com/BusinessMarket/Client/expandIconStock.png"
}, null, -1))
const _hoisted_78 = { style: {"max-width":"300px","font-size":"14px"} }
const _hoisted_79 = { key: 0 }
const _hoisted_80 = { style: {"padding":"10px"} }
const _hoisted_81 = { class: "flex-bwn" }
const _hoisted_82 = { class: "flex-bwn" }
const _hoisted_83 = /*#__PURE__*/_createTextVNode()
const _hoisted_84 = { class: "flex-bwn" }
const _hoisted_85 = { class: "flex-bwn" }
const _hoisted_86 = { key: 1 }
const _hoisted_87 = { class: "show-one-line" }
const _hoisted_88 = { class: "show-one-line" }
const _hoisted_89 = { class: "show-one-line" }
const _hoisted_90 = { key: 0 }
const _hoisted_91 = { class: "flex-center" }
const _hoisted_92 = { class: "inventoryNumList" }
const _hoisted_93 = { class: "flex-center inventoryItem" }
const _hoisted_94 = { class: "inventory-detail show-one-line" }
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "...", -1))
const _hoisted_96 = { style: {"color":"#000000","margin-bottom":"16px"} }
const _hoisted_97 = { class: "cursor-pt flex-center inventoryBtn" }
const _hoisted_98 = { style: {"padding":"4px 0","width":"100%","display":"flex"} }
const _hoisted_99 = {
  type: "button",
  class: "primaryButton1"
}
const _hoisted_100 = { class: "cursor-pt inventoryBtn flex-center" }
const _hoisted_101 = {
  type: "button",
  class: "primaryButton1"
}
const _hoisted_102 = { class: "cursor-pt inventoryBtn flex-center" }
const _hoisted_103 = {
  key: 0,
  style: {"max-width":"400px","font-size":"14px"}
}
const _hoisted_104 = { key: 0 }
const _hoisted_105 = /*#__PURE__*/_createTextVNode("API未連携")
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_107 = [
  _hoisted_105,
  _hoisted_106
]
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_109 = { key: 1 }
const _hoisted_110 = /*#__PURE__*/_createTextVNode(" API連携済")
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_112 = {
  key: 1,
  style: {"max-width":"400px","font-size":"14px"}
}
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_114 = { class: "show-one-line" }
const _hoisted_115 = { class: "show-one-line" }
const _hoisted_116 = { class: "show-one-line" }
const _hoisted_117 = { class: "show-one-line" }
const _hoisted_118 = { class: "show-one-line" }
const _hoisted_119 = { class: "show-one-line" }
const _hoisted_120 = { class: "flex-ter" }
const _hoisted_121 = ["src"]
const _hoisted_122 = {
  class: "show-two-line",
  style: {"width":"120px","text-align":"left"}
}
const _hoisted_123 = ["src"]
const _hoisted_124 = { class: "show-one-line" }
const _hoisted_125 = { class: "show-one-line" }
const _hoisted_126 = { class: "show-one-line" }
const _hoisted_127 = { key: 0 }
const _hoisted_128 = { key: 1 }
const _hoisted_129 = { class: "shopping-info flex-center" }
const _hoisted_130 = { key: 0 }
const _hoisted_131 = {
  key: 1,
  class: "flex-center",
  style: {"color":"#008060"}
}
const _hoisted_132 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  referrerPolicy: "no-referrer",
  style: {"margin-left":"6px","width":"18px","object-fit":"contain"},
  src: _imports_8
}, null, -1))
const _hoisted_133 = { style: {"color":"#388ded"} }
const _hoisted_134 = { class: "el-dialog__body-title" }
const _hoisted_135 = { style: {"padding":"20px","background-color":"#fff"} }
const _hoisted_136 = { key: 0 }
const _hoisted_137 = { style: {"margin-top":"20px","font-size":"16px"} }
const _hoisted_138 = { class: "footer flex-ter-end" }
const _hoisted_139 = { class: "el-dialog__body-title" }
const _hoisted_140 = { style: {"padding":"20px","background-color":"#fff"} }
const _hoisted_141 = { class: "flex" }
const _hoisted_142 = { style: {"width":"200px"} }
const _hoisted_143 = { style: {"height":"60px","background":"#fff","padding":"20px 25px"} }
const _hoisted_144 = { style: {"font-size":"16px","margin-bottom":"10px"} }
const _hoisted_145 = { style: {"font-size":"12px"} }
const _hoisted_146 = { style: {"padding":"20px","background-color":"#fff"} }

import { t, lang } from '@/plugins/i18n'
import { isD2C, useRtfix, isJA, isKO, useSite, useSite2Station, isMultiStore, isShowStockJpBtn, isJpPurchase, getWarehouseByCountry } from '@/store'
import {
  ref,
  reactive,
  nextTick,
  onMounted,
  computed,
  watch,
  toRaw,
  onUnmounted,
  onActivated
} from 'vue'
import DragTableSearch from './components/DragTableSearch/index.vue'
import SalesPerspective from './components/SalesPerspective/index.vue'
// import CountryStock from './components/CountryStock.vue'
import { QuestionFilled } from '@element-plus/icons-vue'
import STable from '@/components/Table/index.vue'
import TableButton from '@/components/Table/TableButton.vue'
import AppLink from '@/components/common/AppLink.vue'
import PSearch from './PSearch.vue'
import MSearch from './MSearch.vue'
import HeaderTips from './components/HeaderTips.vue'
import MeasureSearch from './MeasureSearch.vue'
import AccessoriesDialog from './AccessoriesDialog.vue'
import BindAmazon from '@/views/inshipping/components/BindAmazon.vue'
import OverseaProductSku from '@/views/inshipping/components/OverseaProductSku.vue'
import CustomerProductMsku from '@/views/inshipping/components/CustomerProductMsku.vue'
import CustomSupplierName from '@/views/inshipping/components/customSupplierName.vue'
import Guide from '@/components/guide/index.vue'
import ChooseSendType from './ChooseSendType/index.vue'
import memberEventBox from '@/components/common/MemberEventBox.vue'
import PreviewImgPopupVue from '@/components/common/PreviewImgPopup.vue'
import CommonTip from '@/components/CommonTip/index.vue'
import BindAmazonSkuModal from './components/BindAmazonSkuModal.vue'
import TableLike from '@/components/common/TableLike.vue'
import { showCurrentUnit } from '@/util/useYan'
import {
  d2cproductColumns,
  b2bProductColumns,
  materialsColumns,
  materialsCanAddCart,
  productTableConfig,
  b2bproductTableConfig,
  materialsTableConfig,
  productTypeSnum,
  measureColumns,
  groupTableConfig,
  combinationColumns
} from './data'
import ShoppingPreview from '@/components/common/ShoppingPreview.vue'
import ToolList from './ToolList.vue'
import CopyButton from '@/components/common/CopyButton.vue'
import BatchSearch from '@/components/BatchSearch/index.vue'
import useTabData from '@/util/useTabData'
import VolumeHead from './components/VolumeHead.vue'
import CountryNum from './components/CountryNum.vue'
import {
  getStockList,
  getProductList,
  batchAddProduct,
  addIngredientsProduct,
  batchBindAmazonSku,
  getMeasureList,
  getCombinaProductDetailApi,
  updateStockLog,
  updateSpecificationExcel,
  batchBindCrossMallSkuApi
} from '@/apis/stock'
import useMaterialFilter from './useMaterialFilter'
import useProductFilter from './useProductFilter'
import { ElMessage, ElMessageBox } from 'element-plus'
import { setNoEmptyForm, getJapanTime } from '@/util/common'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { syncAllGoods, getLastTime } from '@/apis/associated'
import { confirmApiUnbind } from '@/util/useConfirm'
import { useRequest } from '@/util/useLoading'

import { getCartAmount } from '@/apis/shopcart'
import { getAdt, setAdt } from '@/util/calcAdt'
import { getCustomerShop, batchQueryCombinationProduct } from '@/apis/order'
import axios from 'axios'
import { exportFileDownload } from '@/util/useExport'
import bus from '@/util/useBus'
import SpecCol from './SpecificationColumn.vue'
import CommonDialog from '@/components/common/CommonDialog.vue'
import { getExcelFileData } from '@/util/useXlsx'
import { uploadAliOSS } from '@/util/useUpload'
import UploadFailTable from '@/views/shopcart/components/UploadFailTable.vue'
import AdditionWarnSetting from './components/AdditionWarnSetting.vue'
import UploadSupplier from './components/UploadSupplier/index.vue'
import { COUNTRY } from '@/global'
import { ShopType } from '@/common/const'
import { useLocalStorage } from '@vueuse/core'
import { MyInventoryRespDTO } from '@/service/order'
import SvgIcon from '@/components/icons/SvgIcon.vue'
import { request } from '@/config/request/interceptors'
import { AdditionTemplateItemRespDTO } from '@/service/settlement.js'
enum Enum_country {
  'CN' = t('中国'),
  'KR' = t('韩国'),
  'JP' = t('日本'),
}


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const tooltipRef = ref()
const isCrossMall = computed(() => store.getters.isCrossMall)
const isTikTokShop = computed(() => store.getters.shopInfo?.customerShopPlatform === ShopType.TIKTOK)
const shopInfo = computed(() => store.getters.shopInfo)
const membership = computed(() => store.getters.membership)
const isJpPurchaseWhite = computed(() => store.getters.isJpPurchase)
// 历史白名单
const historyWhite = ref<any[]>([])
// 销售视角取三方数据子账号白名单
const thirdWhite = ref<any[]>([])
// 视角
const perspective = ref('1')
// 默认全部
const wareHouseType = ref(isD2C() ? '1' : '2')
// 国家仓，默认中国仓
const wareType = ref('CN')
const descCoustomColumnsTipImg = [
  { key: 'ja', url: 'https://static-s.theckb.com/BusinessMarket/Client/desc_ja.png' },
  { key: 'en', url: 'https://static-s.theckb.com/BusinessMarket/Client/desc_en.png' },
  { key: 'ko', url: 'https://static-s.theckb.com/BusinessMarket/Client/desc_ko.png' },
  { key: 'zh', url: 'https://static-s.theckb.com/BusinessMarket/Client/desc_zh.png' }
]
const showCoustomColumnsTipImgVisible = ref(true)
onMounted(async () => {
  const res = await request.apis.thirdShopItem.queryWhiteUserList()
  historyWhite.value = res.data ?? []
  const res1 = await request.apis.thirdShopItem.salesPerspectiveCustomerIds()
  thirdWhite.value = res1.data ?? []
  // 获取内存
  const customTableFilterColumnPrompts = localStorage.getItem('Custom_Table_Filter_Column_Prompts')
  const obj = descCoustomColumnsTipImg.find(item => item.key === lang)
  //   如果已经存在直接不展示
  if (customTableFilterColumnPrompts && customTableFilterColumnPrompts === obj?.url) {
    showCoustomColumnsTipImgVisible.value = false
  }
})
/** 关闭提示 */
const closeDescCoustomColumnsTipImg = (url: string) => {
  showCoustomColumnsTipImgVisible.value = false
  localStorage.setItem('Custom_Table_Filter_Column_Prompts', url)
}

/** 组合商品 */
const comboProduct = ({ productSkuImg, productPropertiesName, productTitle, shopProductSku, customerProductMsku }: MyInventoryRespDTO) => {
  store.commit('goods/CombinedInfo', {
    combinationProductMainImg: productSkuImg,
    combinationProductProp: productPropertiesName,
    combinationProductName: productTitle,
    stockShopProductSku: shopProductSku,
    customerProductMsku: customerProductMsku
  })
  store.commit('goods/groupList', [])
  router.push(useRtfix('groupProduct'))
}

const router = useRouter()
const route = useRoute()
const amazonSkuVisible = ref(false)
/** 2b 平台库存是否展开 */
const platformInventoryExpand = ref(false)

/** 2b 平台库存点击是否展开 */
const clickPlatformInventoryExpand = () => {
  platformInventoryExpand.value = !(platformInventoryExpand.value)
}

const isAmazon = ref()
const syncTime = ref()
if (!isD2C()) {
  getCustomerShop().then((res: any) => {
    if (res.success) {
      isAmazon.value =
        res.data.customerShopPlatform === 4 && res.data.customerShopAuthStatus
    }
  })
  getLastTime().then((res: any) => {
    if (res.success) {
      syncTime.value = res.data.date
    }
  })
}

const calMaterialsColumns = computed(() => {
  if (isTikTokShop.value && wareHouseType.value === '3') {
    return materialsColumns.filter(i => (i.prop !== 'noStockQuantity'))
  } else {
    return materialsColumns
  }
})
// 国家枚举
const file = ref()
const fileUploadErrorList = ref([])

const upload = (uploadFile: any) => {
  if (uploadFile.size > 20 * 1024 * 1024) {
    ElMessage.warning(t('文件大于20M,请重新上传'))
    return false
  }
  file.value = uploadFile
  importVisible.value = false
  validUpload()
  return false
}

const validUpload = () => {
  const fd = new FormData()
  fd.append('file', file.value)
  store.commit('status/loading', true)
  ElMessage.success(t('读取文件中，即将更新数据'))

  const info: any = {
    1: '存在多个一样ckb sku: {sku}',
    2: '{sku} 该ckb sku不存在',
    3: '客户sku过长',
    4: '商品规格过长'
  }

  updateSpecificationExcel(fd).then(res => {
    store.commit('status/loading', false)
    refreshTable()
    if (res.data?.errorList?.length) {
      importErrorVisible.value = true
      fileUploadErrorList.value = res.data?.errorList.map((v: any, i: any) => {
        return {
          rowNumber: v.rowIndex,
          error: t(info[v.errorType], { sku: v.productSku ?? '' })
        }
      })
    }
    file.value = null
  })
}

const importVisible = ref(false)
const importErrorVisible = ref(false)

const logData = ref<any>(false)
const openOptLog = (row: any) => {
  if (logData.value) return
  logData.value = []
  updateStockLog({
    shopProductSku: row.shopProductSku,
    pageNum: 1,
    pageSize: 9999
  }).then(res => {
    const scenes: any = {
      1: t('在库管理编辑'),
      2: t('订单编辑'),
      3: t('组合商品编辑'),
      4: t('购物车下单')
    }
    const type: any = {
      1: t('修改客户商品规格为'),
      2: t('修改客户SKU为')
    }
    if (res.success) {
      logData.value = res.data.records.map((v: any) => {
        return {
          time: getJapanTime(v.createTime, 'YYYY-MM-DD HH:mm'),
          scenes: scenes[v.scenes],
          action: type[v.type] + v.newValue
        }
      })
    }
  })
}

const popverRef: any = ref()
const showPopver = (index: number) => {
  popverRef.value.showPopver(index)
}
const createType = ref(1)
const sendType = ref(2)
const sendTypeVisible = ref(false)

const createTipsType = computed(() => {
  if (!productSelectionList.value.length) {
    return true
  }
  const has0available = (productSelectionList.value || []).some(
    (item: any) => item.availableQuantity < 1
  )
  return has0available
})
const createBtnNum = computed(() => {
  const has0available = (productSelectionList.value || []).filter(
    (item: any) => item.availableQuantity > 0
  ).length
  return has0available
})
const openCreateType = () => {
  if (!isJA()) {
    // 韩国直接其他跳转
    sendType.value = 0
    chooseCall()
    return
  }
  //   productSelectionList.value
  //   判断勾选的是否仓是一致的
  const isAConsistent = productSelectionList.value.every((item: any) => item.goodsCountry && item.goodsCountry === productSelectionList.value[0].goodsCountry)
  //   若是韩国商品授权了且商品不是一个仓的做提示
  if (isMultiStore() && !isAConsistent) {
    ElMessage.warning(t('多个仓库的商品无法创建一个国际发货单'))
    return
  }
  if (isAmazon.value) {
    createType.value = 1
  } else {
    createType.value = 2
  }
  createTypeVisible.value = true
  //   直接取第一个商品的商品所在仓就行
  wareType.value = productSelectionList.value[0].goodsCountry
}
const creatShipping = () => {
  createTypeVisible.value = false
  if (createType.value === 1) {
    router.push(
      useRtfix('CreateReplenishment', {
        params: {
          wareType: wareType.value
        },
        query: {
          shopProductSku: (productSelectionList.value.filter(
            (item: any) => item.availableQuantity > 0
          ) || [])
            .map((e: any) => e.shopProductSku)
            .join(',')
        }
      })
    )
  } else {
    chooseCall()
  }
}
const chooseCall = () => {
  router.push(
    useRtfix('CreateShipping', {
      params: {
        sendType: sendType.value,
        wareType: wareType.value
      },
      query: {
        shopProductSku: (productSelectionList.value.filter(
          (item: any) => item.availableQuantity > 0
        ) || [])
          .map((e: any) => e.shopProductSku)
          .join(',')
      }
    })
  )
}

const onClickBindLoading = ref(false)
const onClickBinding = () => {
  onClickBindLoading.value = true
  const api = isCrossMall.value ? batchBindCrossMallSkuApi : batchBindAmazonSku
  api()
    .then((res: any) => {
      if (res.success) {
        ElMessage.success(isCrossMall.value ? t('CROSS MALL sku绑定成功') : t('Amazon sku绑定成功'))
      }
    })
    .finally(() => {
      onClickBindLoading.value = false
    })
}

const productPageData = ref({
  page: 1,
  limit: 30
})

const materialsPageData = ref({
  page: 1,
  limit: 30
})

const measurePageData = ref({
  page: 1,
  limit: 30
})
const [mSearchForm, mSortForm, mFilterData] = useMaterialFilter()
const [pSearchForm, pSortForm, pFilterData] = useProductFilter()
const measureForm = ref({})

const tableWidth = ref(0)
const showBtn = ref(false)
onMounted(async () => {
  if (route.query.stock === 'materials') {
    setMaterialsSearch()
  }
  pSearchForm.value = {
    startAvailableQuantity: 1,
    endAvailableQuantity: 999999999,
    productSkuOrName: route.query.productSkuOrName ?? ''
  }
  refreshTable(true)
  changeTableWidth()
  window.addEventListener('resize', changeTableWidth)
  showBtn.value = await isShowStockJpBtn()
})

const setMaterialsSearch = () => {
  if (route.params?.ingredientsSkuList) {
    mSearchForm.value = {
      ingredientsSkuList: String(route.params.ingredientsSkuList).split(',')
    }
  }
  setStatus({ ...route.query, ...route.params }, refreshTable(true))
}

const createTypeVisible = ref(false)
const store = useStore()
const customerShopName = computed(() => store.getters.shopname)

const createAssociated = (row: any) => {
  router.push(
    useRtfix('CreateAssociated', {
      query: {
        shopItemId: row.shopItemId ? row.shopItemId : '',
        productCode: row.shopItemId ? '' : (row.productCode ?? row.productSku),
        productType: row.productType,
        productSku: row.productSku
      }
    })
  )
}

const rowItem = ref()
const bindAmazonVisible = ref(false)
const openBindAmazon = (row: any) => {
  rowItem.value = row
  amazonSkuVisible.value = true
}

const [syncLoading, syncApi] = useRequest(syncAllGoods)
const setSyncProduct = async () => {
  const unbind = await confirmApiUnbind()
  if (unbind) return
  syncApi().then((res: any) => {
    if (res.success) {
      ElMessage.success(t('处理中，需要1～2分钟'))
      // setTimeout(() => {
      //   ElMessage.success(t('更新完成-执行刷新'))
      //   refreshTable(true)
      // }, 3000)
    }
  })
}

const skuKeyDist: any = {
  color: t('颜色'),
  size: t('尺寸')
}

const refreshTable = (type?: boolean) => {
  productRef.value && productRef.value && productRef.value.clearSelection && productRef.value.clearSelection()
  if (tabData.value === 'materials') {
    if (type) {
      materialsPageData.value = {
        page: 1,
        limit: 30
      }
    }
    refreshMaterials()
  } else if (tabData.value === 'product') {
    if (type) {
      productPageData.value = {
        page: 1,
        limit: 30

      }
    }
    refreshProduct()
  } else {
    if (type) {
      measurePageData.value = {
        page: 1,
        limit: 30
      }
    }
    refreshMeasure()
  }
}

const productRef = ref()
const refreshProduct = () => {
  nextTick(() => {
    productRef.value && productRef.value.getData()
  })
}

const materialsRef = ref()
const refreshMaterials = () => {
  nextTick(() => {
    materialsRef.value && materialsRef.value.getData()
  })
}

const measureRef = ref()
const refreshMeasure = () => {
  nextTick(() => {
    measureRef.value && measureRef.value.getData()
  })
}

const materialsFlag = ref(false)
const dataListener = (data: any) => {
  for (const e of data) {
    if (!e.relatedFlag) {
      materialsFlag.value = true
      break
    }
  }
}

const accessoriesVisible = ref(true)
const { tabData, stock, setStatus } = useTabData(
  { TabName: 'stock', EmptyTabName: 'product' },
  () => refreshTable(true)
)

const productSelectionList: any = reactive({ value: [] })
const productSelection = (val: any[]) => {
  productSelectionList.value = val
}

const productSort = (val: any) => {
  const { column, order } = val
  if (order === 'descending') {
    pSortForm.ascs = []
    pSortForm.descs = column?.sortable ? [column.sortable] : []
  } else {
    pSortForm.ascs = column?.sortable ? [column.sortable] : []
    pSortForm.descs = []
  }
  refreshTable()
}

const materialsSort = (val: any) => {
  const { column, order } = val
  if (order === 'descending') {
    mSortForm.ascs = []
    mSortForm.descs = column?.sortable ? [column.sortable] : []
  } else {
    mSortForm.ascs = column?.sortable ? [column.sortable] : []
    mSortForm.descs = []
  }
  refreshTable()
}

const productAddSingleCart = async (e: any) => {
  e.productAddLoading = true
  // 商品类型: 1-普通商品; 2-OEM商品; 3-组合商品

  try {
    let list: any = []
    if (e.productType === 1 && e.oemBusinessType !== 2) {
      // 堂吉柯德todo 1, 9, 13, 14, 15, 17, 30, 38
      const cartAdditionList: any = e.allIncludeAvailableQuantity > 0 && e.switchAllIncludePriceJp === 1 ? await getAdt([].map(v => ({ additionId: v })), false, getWarehouseByCountry()) : await setAdt(e.productCategoryFrontendNdId, 'cartAdditionList', 'noAdditionalFlag', [], undefined, e.goodsCountry === COUNTRY.KR)
      list = [
        {
          productType: e.productType,
          productSku: e.productSku,
          orderQuantity: 1,
          allIncludeFlag: e.allIncludeAvailableQuantity > 0 ? 1 : 0,
          ...cartAdditionList
        }
      ]
    } else if (e.productType === 2 || e.oemBusinessType === 2) {
      list = [
        {
          productType: 2,
          productSku: e.productSku,
          orderQuantity: 1,
          oemOrderType: e.searchSourceOrderRepurchaseApplyId ? 4 : 2,
          searchSourceOrderCode: e.searchSourceOrderNo,
          searchSourceOrderId: e.searchSourceOrderId,
          searchSourceSupplierPriceId: e.searchSourcePriceId
        }
      ]
    } else if (e.productType === 3) {
      let combinationProductAdt = await batchQueryCombinationProduct({ combinationProductSkus: [e.productSku], withSubProduct: 1 })
      if (combinationProductAdt.code === '0') {
        combinationProductAdt = combinationProductAdt.data[0].combinationProductItems
      } else {
        return
      }
      const combinationProductItemAddCartList = await Promise.all(
        e.combinationProductItemList.map(async (e: any) => {
          const combinationProductAdtItemCache = combinationProductAdt.filter((y: any) => y.shopProductSku === e.shopProductSku)[0]
          const cartAdditionList: any = await setAdt(e.productCategoryFrontendNdId, 'combinationProductItemAdditionList', 'noAdditionalFlag', combinationProductAdtItemCache?.additionList, combinationProductAdtItemCache?.noAdditionalFlag, e.goodsCountry === COUNTRY.KR)
          return {
            ...cartAdditionList,
            shopProductSku: e.shopProductSku
          }
        })
      )
      list = [
        {
          productType: e.productType,
          productSku: e.productSku,
          orderQuantity: 1,
          combinationProductItemAddCartList: combinationProductItemAddCartList
        }
      ]
    }
    if (e.oemBusinessType === 2) {
      const res = await request.settlement.addition.customerTemplateDefault({
        customerShopId: store.getters.curShop,
        systemSource: store.getters.plat === 'd2c' ? 1 : 2
      } as any)
      if (res.data?.templateStatus === 1) {
        list[0].cartAdditionList = res.data?.items ?? []
      }
    }
    await addProduct(list)
    refreshTable()
    // 当开通韩国商品授权之后才需要传。若是韩国商品跳转购物车选择韩国购物车
    const allSameCountry = isMultiStore() ? e.goodsCountry : undefined
    showAddCartInfo(1, allSameCountry)
    e.productAddLoading = false
  } catch (error) {
    e.productAddLoading = false
  }
}
const transferJPLoading = ref(false)
const transferJPVisible = ref(false)
const transferJP = () => {
  const availableQuantity = productSelectionList.value.some((v: any) => !v.availableQuantityCn || v.availableQuantityCn <= 0)
  if (availableQuantity) return ElMessage.warning(t('当前所选商品中含有库存数为0的商品'))
  transferJPVisible.value = true
}
const jumpToCart = (params?: any) => {
  transferJPVisible.value = false
  useLocalStorage('_transfer_jp_products_', []).value = productSelectionList.value
  router.push('/ja/inshipping_d2c/StockJp')
}
const batchProductAddLoading = ref(false)
const productAddBatchCart = async () => {
  if (!productSelectionList.value.length) {
    return ElMessage.warning(t('请选择商品'))
  }
  batchProductAddLoading.value = true
  try {
    const commonProductList = []
    const combinationProductList = []
    const oemProductList:any = []
    for (const v of productSelectionList.value) {
      if (v.productType === 2 || v.oemBusinessType === 2) {
        oemProductList.push({
          productType: 2,
          orderQuantity: 1,
          productSku: v.productSku,
          oemOrderType: v.searchSourceOrderRepurchaseApplyId ? 4 : 2,
          searchSourceOrderCode: v.searchSourceOrderNo,
          searchSourceOrderId: v.searchSourceOrderId,
          searchSourceSupplierPriceId: v.searchSourcePriceId
        })
      } else if (v.productType === 1 && v.oemBusinessType !== 2) {
        commonProductList.push(v)
      } else if (v.productType === 3) {
        combinationProductList.push(v)
      }
    }
    const list: any = [...oemProductList]
    const combinationProductSkus = productSelectionList.value.filter((v: any) => v.productType === 3).map((y: any) => y.productSku)
    let combinationProductAdts = {}
    if (combinationProductSkus.length) {
      combinationProductAdts = await batchQueryCombinationProduct({ combinationProductSkus: combinationProductSkus, withSubProduct: 1 })
      if (combinationProductAdts.code !== '0') {
        batchProductAddLoading.value = false
        return
      }
    }
    await Promise.all([
      ...commonProductList.map(async (v: any) => {
        const { productType, productSku } = v
        // 堂吉柯德todo 1, 9, 13, 14, 15, 17, 30, 38
        const cartAdditionList: any = v.allIncludeAvailableQuantity > 0 && v.switchAllIncludePriceJp === 1 ? await getAdt([].map(v => ({ additionId: v })), false, getWarehouseByCountry()) : await setAdt(v.productCategoryFrontendNdId, 'cartAdditionList', 'noAdditionalFlag', [], undefined, v.goodsCountry === COUNTRY.KR)
        list.push({
          productType,
          productSku,
          orderQuantity: 1,
          allIncludeFlag: v.allIncludeAvailableQuantity > 0 ? 1 : 0,
          ...cartAdditionList
        })
      }),
      ...combinationProductList.map(async (v: any) => {
        const { productType, productSku } = v
        const combinationProductAdt = combinationProductAdts.data.filter((y: any) => y.combinationProductSku === v.productSku)[0].combinationProductItems
        const combinationProductItemAddCartList = await Promise.all(
          v.combinationProductItemList.map(async (e: any) => {
            const combinationProductAdtItemCache = combinationProductAdt.filter((y: any) => y.shopProductSku === e.shopProductSku)[0]
            const cartAdditionList: any = await setAdt(
              e.productCategoryFrontendNdId,
              'combinationProductItemAdditionList',
              'noAdditionalFlag',
              combinationProductAdtItemCache?.additionList,
              combinationProductAdtItemCache?.noAdditionalFlag,
              e.goodsCountry === COUNTRY.KR
            )
            return {
              ...cartAdditionList,
              shopProductSku: e.shopProductSku
            }
          })
        )
        list.push({
          productType,
          productSku,
          orderQuantity: 1,
          combinationProductItemAddCartList: combinationProductItemAddCartList
        })
      })
    ])
    if (productSelectionList.value.find((i:any) => i.oemBusinessType === 2)) {
      const res = await request.settlement.addition.customerTemplateDefault({
        customerShopId: store.getters.curShop,
        systemSource: store.getters.plat === 'd2c' ? 1 : 2
      } as any)
      if (res.data?.templateStatus === 1) {
        list.forEach(i => {
          if (productSelectionList.value.find(j => j.productSku === i.productSku)?.oemBusinessType === 2) {
            i.cartAdditionList = res.data?.items ?? []
          }
        })
      }
    }

    await addProduct(list)
    // 当开通韩国商品授权之后才需要传。若是韩国商品跳转购物车选择韩国购物车
    //   判断勾选的是否仓是一致的
    const isAConsistent = productSelectionList.value.every((item: any) => item.goodsCountry && item.goodsCountry === productSelectionList.value[0].goodsCountry)
    const allSameCountry = isMultiStore() && isAConsistent ? productSelectionList.value[0].goodsCountry : undefined
    showAddCartInfo(productSelectionList.value.length, allSameCountry)
    refreshTable()
    batchProductAddLoading.value = false
    productRef.value.clearSelection()
  } catch (error) {
    console.error(error)
    batchProductAddLoading.value = false
  }
}
const materialSelectionList: any = ref([])
const materialSelection = (val: any[]) => {
  materialSelectionList.value = val
}
const materialAddSingleCart = async (e: any) => {
  e.materialAddLoading = true
  try {
    await addIngredient([
      {
        productSku: e.ingredientsSku,
        orderQuantity: 1,
        oemOrderType: e.searchSourceOrderRepurchaseApplyId ? 4 : 2,
        searchSourceOrderId: e.searchSourceOrderId,
        searchSourceOrderCode: e.searchSourceOrderNo
        // searchSourceOrderRepurchaseApplyId: e.searchSourceOrderRepurchaseApplyId
      }
    ])
    e.materialAddLoading = false
    refreshTable()
    showAddCartInfo(1)
  } catch (error) {
    e.materialAddLoading = false
  }
}
const batchMaterialsAddLoading = ref(false)
const materialAddBatchCart = async () => {
  if (!materialSelectionList.value.length) {
    return ElMessage.warning(t('请选择商品'))
  }
  batchMaterialsAddLoading.value = true
  try {
    await addIngredient(
      materialSelectionList.value.map((e: any) => ({
        productSku: e.ingredientsSku,
        orderQuantity: 1,
        oemOrderType: e.searchSourceOrderRepurchaseApplyId ? 4 : 2,
        searchSourceOrderId: e.searchSourceOrderId,
        searchSourceOrderCode: e.searchSourceOrderNo
        // searchSourceOrderRepurchaseApplyId: e.searchSourceOrderRepurchaseApplyId
      }))
    )
    batchMaterialsAddLoading.value = false
    refreshTable()
    showAddCartInfo(materialSelectionList.value.length)
  } catch (error) {
    batchMaterialsAddLoading.value = false
  }
}

const addProduct = (params: any) => {
  return new Promise<void>((resolve, reject) => {
    batchAddProduct(params)
      .then(async (res: any) => {
        if (res.success) {
          resolve()
        } else {
          reject(new Error())
        }
      })
      .catch(() => {
        reject(new Error())
      })
  })
}

const addIngredient = (params: any) => {
  return new Promise<void>((resolve, reject) => {
    addIngredientsProduct(params)
      .then(async (res: any) => {
        if (res.success) {
          resolve()
        } else {
          reject(new Error())
        }
      })
      .catch(() => {
        reject(new Error())
      })
  })
}

const showAddCartInfo = async (len: any, allSameCountry?: string) => {
  const amount = await getCartAmount().then((res) => res.data)
  ElMessageBox.confirm(
    `
        <div>${t('X件商品已添加至购物车').replace('X', len)}</div>
        <div>${t('当前购物车共X种商品').replace('X', amount)}</div>
      `,
    t('添加成功'),
    {
      dangerouslyUseHTMLString: true,
      confirmButtonText: t('去结算'),
      cancelButtonText: t('留在此页'),
      type: 'success'
    }
  ).then(() => {
    // 国家都一样的商品,且全为韩国商品
    if (allSameCountry && allSameCountry === 'KR') {
      router.push(useRtfix('shopcart', { query: { sc: 'KR' } }))
      return
    }
    router.push(useRtfix('shopcart'))
  })
}

const showProductRed = ref(true)
const setShowProductRed = (type: boolean) => {
  showProductRed.value = type
  b2bPColumns.value = b2bPColumns.value.map((e: any) => {
    e?.className?.includes('red-set') && (e.hidden = !type)
    return e
  })
}
const showProductBlue = ref(true)
const setShowProductBlue = (type: boolean) => {
  showProductBlue.value = type
  b2bPColumns.value = b2bPColumns.value.map((e: any) => {
    e?.className?.includes('blue-set') && (e.hidden = !type)
    return e
  })
}
const getNewB2bProductColumns = (b2bProductColumn) => {
  // 使用结构化克隆代替 JSON.parse(JSON.stringify) 以提高性能
  const _b2bProductColumn = structuredClone ? structuredClone(b2bProductColumn) : JSON.parse(JSON.stringify(b2bProductColumn))
  return _b2bProductColumn.map((e: any) => {
    // 默认初始化时，平台库存需要处理默认值
    // 该三项固定不变
    const whiteList = ['availableQuantity', 'lockQuantity', 'unableProcessDefectiveProducts', 'pendingStorage']
    // 只有平台库存需要特殊处理
    if (e.slotHeadName !== 'platformInventory') {
      return e
    }
    /** 从原先的column中复制一份 */
    const newPlatformInventoryObj = _b2bProductColumn.find(item => item.slotHeadName === 'platformInventory')?.children ?? []
    const children = newPlatformInventoryObj?.filter(item => {
      if (whiteList.includes(item.prop)) {
        return true
      }
      if (item.isDefaultExpand === true) {
        return true
      }

      return false
    })
    //   达成点击展开，展示更多项的功能
    return { ...e, hidden: false, children: children }
  })
}

const b2bProductColumnsFinal = ref(b2bProductColumns.filter(v => !v.isCrossMall || (v.isCrossMall === '0' && !isCrossMall.value) || (v.isCrossMall === '1' && isCrossMall.value)))
const b2bPColumns = ref(
  getNewB2bProductColumns(b2bProductColumnsFinal.value)
)

const selectList = computed({
  get: () => b2bPColumns.value,
  set: (v) => {
    b2bPColumns.value = v
  }
})

watch(
  () => b2bPColumns.value,
  (val) => {
    showProductRed.value = val.some(
      (e: any) => e?.className?.includes('red-set') && !e.hidden
    )
    showProductBlue.value = val.some(
      (e: any) => e?.className?.includes('blue-set') && !e.hidden
    )
  }
)

watch(
  () => isAmazon.value,
  (val) => {
    b2bPColumns.value = b2bPColumns.value.map((e: any) => {
      e?.className?.includes('amazon-td') && (e.hidden = !val)
      return e
    })
  }
)

/** d2c最终的columns */
const d2cLastProductColumns: any = ref(d2cproductColumns)
// 2b 监听/2c  平台库存是否展开

const d2cProductColumnsFinal = computed(() => {
  // 使用结构化克隆代替 JSON.parse(JSON.stringify) 以提高性能
  const cloned = structuredClone ? structuredClone(d2cproductColumns) : JSON.parse(JSON.stringify(d2cproductColumns))
  return cloned.filter((e: any) => {
    if (e.children) {
      e.children = e.children.filter((child: any) => {
        return child.wareHouseTypes.includes(wareHouseType.value)
      })
    }
    return e.wareHouseTypes.includes(wareHouseType.value)
  })
})

watch(
  () => platformInventoryExpand.value,
  (val) => {
    if (!isD2C()) {
      //   nextTick(() => {
      //     d2cLastProductColumns.value
      //   })
      // } else {
      // 该三项固定不变
      const whiteList = ['availableQuantity', 'lockQuantity', 'unableProcessDefectiveProducts', 'pendingStorage']
      b2bPColumns.value = b2bPColumns.value.map((e: any) => {
        // 只有平台库存需要特殊处理
        if (e.slotHeadName !== 'platformInventory') {
          return e
        }
        /** 从原先的column中复制一份 */
        const newPlatformInventoryObj = b2bProductColumns.find(item => item.slotHeadName === 'platformInventory')?.children ?? []
        const children = newPlatformInventoryObj?.filter(item => {
          if (whiteList.includes(item.prop)) {
            return true
          }
          if (item.isDefaultExpand === !val) {
            return true
          }

          return false
        })
        //   达成点击展开，展示更多项的功能
        return { ...e, children: children }
      })
    }
  }, {
    immediate: true
  }
)

watch(() => wareHouseType.value, () => {
  d2cLastProductColumns.value = d2cProductColumnsFinal.value
}, {
  immediate: true
})

// 是否为日本站点
// const isJapanStation = useSite2Station() === 'JapanStation'
const productColumns = computed(() => {
  // 使用结构化克隆代替 JSON.parse(JSON.stringify) 以提高性能
  let data = isD2C()
    ? (structuredClone ? structuredClone(d2cLastProductColumns.value) : JSON.parse(JSON.stringify(d2cLastProductColumns.value))).filter((i) => {
      return platformInventoryExpand.value || i.prop !== 'pendingStorage'
    })
    : b2bPColumns.value.filter((e: any) => !e.hidden)
  // 只有开通韩国授权才有商品所在仓
  if (!isMultiStore()) {
    data = data.filter((item) => item.prop !== 'goodsCountry')
  }
  if (isD2C()) {
    data = data.filter((e: any) => {
      if (e.children) {
        e.children = e.children.filter((child: any) => {
          return child.wareHouseTypes.includes(wareHouseType.value)
        })
      }
      return e.wareHouseTypes.includes(wareHouseType.value)
    })
  }

  // if (wareHouseType.value === '3') {
  //   data = data.filter(i => !['unableProcessDefectiveProducts', 'pendingStorage'].includes(i.prop))
  //   data.forEach(i => {
  //     if (i.children) {
  //       i.children = i.children?.filter(j => !['thirdPendingStorage', 'thirdUnableProcessDefectiveProducts'].includes(j.prop))
  //     }
  //   })
  // }

  return data
})

const realProductTableConfig = computed(() => {
  return {
    ...(isD2C() ? productTableConfig : b2bproductTableConfig),
    dataFormatFn: (data: any) => {
      return data.map((i: any) => {
        return {
          ...i
          // productType: i.quickResponseOrderType === 2 ? 2 : i.productType
        }
      })
    }
  }
})

const realPaginationConfig = computed(() => {
  return isD2C()
    ? undefined
    : {
      pageSize: 10,
      pageSizes: [10]
    }
})

const exportProductLoading = ref(false)
const exportProduct = () => {
  let data: any = {
    wareHouseType: wareHouseType.value
  }
  if (productSelectionList.value && productSelectionList.value.length > 0) {
    data.shopProductSkuIdList = productSelectionList.value.map(
      (e: any) => e.shopProductSkuId
    )
  } else {
    data = {
      ...pSearchForm.value,
      ...pSortForm,
      ...productPageData.value,
      wareHouseType: wareHouseType.value
    }
  }
  exportProductLoading.value = true
  axios({
    method: 'post',
    url: process.env.VUE_APP_URL + '/order/shop/product/sku/exportAmazonSku',
    responseType: 'blob',
    headers: {
      'X-AuthToken': store.getters.token,
      'X-AuthShopId': store.getters.curShop,
      'X-GRAY-TAG': process.env.VUE_APP_X_GRAY_TAG || '',
      'X-stationCode': useSite2Station(),
      'X-Platform': 'PC',
      'X-Appname': 'ckb-client-pc'
    },
    data
  })
    .then((res: any) => {
      exportFileDownload(res, { name: isJA() ? '在庫視点‐CKB SKU_' : t('我的库存') })
    })
    .finally(() => {
      exportProductLoading.value = false
      // refreshTable()
    })
}

const copy = (productSku: any) => {
  navigator &&
    navigator.clipboard &&
    navigator.clipboard
      .writeText(productSku)
      .then(() => {
        ElMessage.success(t('复制成功'))
      })
      .catch(() => {
        // Clipboard API 失败时的静默处理
      })
}

const batchSearchParams = ref({})
const isBatchSearch = ref(false) // 是否批量搜索
bus.on('batchSearchStock', (params: any) => {
  isBatchSearch.value = true
  batchSearchParams.value = params
  refreshTable(true)
})

watch(() => wareHouseType.value, () => {
  isBatchSearch.value = false
  refreshTable(true)
})

const searchForm = () => {
  isBatchSearch.value = false
  refreshTable(true)
}

const orderHandle = function (row: any) {
  router.push(useRtfix('SubstandardList', { query: { shopProductSku: row.shopProductSku } }))
}
// 组合商品展开
const handleExpandRow = (val: any, flag: boolean) => {
  if (flag) {
    val.loading = true
    getCombinaProductDetailApi(val.productSku).then((res: any) => {
      val.combinationProductItemList = res.data?.combinationProductItemList || []
    }).finally(() => {
      val.loading = false
    })
  }
}

onUnmounted(() => {
  window.removeEventListener('resize', changeTableWidth)
})

const changeTableWidth = () => {
  // 计算展开table的宽度
  tableWidth.value = document.querySelector('.product-table')?.clientWidth || 0
}
/** 筛选表格-确认选择 */
const handleOkSelectColumns = (data) => {
  if (isD2C()) {
    d2cLastProductColumns.value = []
    nextTick(() => {
      d2cLastProductColumns.value = data
    })
    tooltipRef.value.onClose()
    return
  }

  // filter((e: any) => !e.hidden)
  b2bPColumns.value = []
  nextTick(() => {
    b2bPColumns.value = []
    b2bPColumns.value = getNewB2bProductColumns(data)
  })
  tooltipRef.value.onClose()
}

// 辅料不足提醒
const additionWarnVisible = ref(false)

return (_ctx: any,_cache: any) => {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ElTag = _resolveComponent("ElTag")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_tree = _resolveComponent("el-tree")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["stock", _unref(useSite)()])
  }, [
    (!_unref(isD2C)())
      ? (_openBlock(), _createBlock(CommonTip, {
          key: 0,
          name: "expressTime,stopWarehouse"
        }))
      : _createCommentVNode("", true),
    (_unref(isD2C)() && _unref(shopInfo)?.authStatus === '1')
      ? (_openBlock(), _createBlock(_component_el_tabs, {
          key: 1,
          modelValue: perspective.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((perspective).value = $event)),
          type: "card"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_tab_pane, {
              label: _unref(t)('采购视角'),
              name: "1"
            }, null, 8, ["label"]),
            _createVNode(_component_el_tab_pane, {
              label: _unref(t)('销售视角'),
              name: "2"
            }, null, 8, ["label"])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode(_component_el_tabs, {
      modelValue: _unref(tabData),
      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (_isRef(tabData) ? (tabData).value = $event : null)),
      type: "card",
      class: _normalizeClass(["demo-tabs", {
      'p-10': _unref(isD2C)()
    }])
    }, {
      default: _withCtx(() => [
        _withDirectives(_createVNode(MSearch, {
          form: _unref(mSearchForm),
          "onUpdate:form": [
            _cache[2] || (_cache[2] = ($event: any) => (_isRef(mSearchForm) ? (mSearchForm).value = $event : null)),
            searchForm
          ]
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_el_button, {
                loading: batchMaterialsAddLoading.value,
                onClick: materialAddBatchCart,
                style: {"margin-right":"12px","color":"#007fff","border":"1px solid #007fff"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)("批量加入购物车")), 1)
                ]),
                _: 1
              }, 8, ["loading"]),
              (_unref(isJA)())
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (additionWarnVisible.value = true)),
                    style: {"margin-right":"12px","color":"#007fff","border":"1px solid #007fff"}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)("设置辅料不足提醒")), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["form"]), [
          [_vShow, _unref(tabData) === 'materials']
        ]),
        _withDirectives(_createVNode(PSearch, {
          key: wareHouseType.value,
          form: _unref(pSearchForm),
          "onUpdate:form": [
            _cache[3] || (_cache[3] = ($event: any) => (_isRef(pSearchForm) ? (pSearchForm).value = $event : null)),
            searchForm
          ],
          "is-amazon": isAmazon.value,
          wareHouseType: wareHouseType.value
        }, null, 8, ["form", "is-amazon", "wareHouseType"]), [
          [_vShow, _unref(tabData) === 'product']
        ]),
        (_unref(isD2C)()&&_unref(isJA)())
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", {
                  class: _normalizeClass(["tabName", { active: wareHouseType.value === '1' }]),
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (wareHouseType.value = '1'))
                }, _toDisplayString(_unref(t)('全部')), 3),
                _createElementVNode("div", {
                  class: _normalizeClass(["tabName", { active: wareHouseType.value === '2' }]),
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (wareHouseType.value = '2'))
                }, [
                  _hoisted_4,
                  _createTextVNode(" " + _toDisplayString(_unref(t)('中国仓')), 1)
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["tabName", { active: wareHouseType.value === '3' }]),
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (wareHouseType.value = '3'))
                }, [
                  _hoisted_5,
                  _createTextVNode(" " + _toDisplayString(_unref(t)('日本仓')), 1)
                ], 2)
              ])
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_el_tab_pane, {
          label: _unref(t)('我的商品库存'),
          name: "product",
          class: "productClass"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_el_button, {
                    type: "success",
                    loading: batchProductAddLoading.value,
                    onClick: productAddBatchCart,
                    disabled: !_unref(productSelectionList)?.value?.length
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)("批量加购")) + " ", 1),
                      (_unref(productSelectionList)?.value?.length)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_9, "(" + _toDisplayString(_unref(productSelectionList)?.value?.length) + ")", 1))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["loading", "disabled"]),
                  _createVNode(CommonDialog, {
                    visible: transferJPVisible.value,
                    width: 500,
                    onOk: _cache[7] || (_cache[7] = ($event: any) => (jumpToCart('mode=2'))),
                    onCancel: _cache[8] || (_cache[8] = ($event: any) => (transferJPVisible.value = false)),
                    footer: true,
                    title: _unref(t)('配送')
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("div", null, _toDisplayString(_unref(t)('发货仓库2')), 1),
                          _createVNode(_component_el_input, {
                            "model-value": _unref(t)('中国仓库'),
                            disabled: "",
                            style: {"width":"160px"}
                          }, null, 8, ["model-value"])
                        ]),
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("div", null, _toDisplayString(_unref(t)('配送到')), 1),
                          _createVNode(_component_el_input, {
                            "model-value": _unref(t)('日本仓库'),
                            disabled: "",
                            style: {"width":"160px"}
                          }, null, 8, ["model-value"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        _createTextVNode(_toDisplayString(_unref(t)('店铺')) + ": ", 1),
                        _createElementVNode("span", null, _toDisplayString(_unref(customerShopName)), 1)
                      ])
                    ]),
                    _: 1
                  }, 8, ["visible", "title"]),
                  (!_unref(isD2C)())
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 0,
                        type: "primary",
                        onClick: openCreateType,
                        disabled: !_unref(createBtnNum),
                        style: {"position":"relative","font-size":"12px","color":"var(--fcolor) !important","border":"1px solid var(--fcolor)"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)("创建国际发货")) + " ", 1),
                          (_unref(createBtnNum))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_14, "(" + _toDisplayString(_unref(createBtnNum)) + ")", 1))
                            : _createCommentVNode("", true),
                          (_unref(createTipsType) && _unref(productSelectionList)?.value?.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_unref(t)('仅良品数大于0的可创建国际发货单')), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["disabled"]))
                    : _createCommentVNode("", true),
                  (!_unref(isD2C)() && (isAmazon.value || _unref(isCrossMall)))
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 1,
                        type: "info",
                        loading: onClickBindLoading.value,
                        onClick: onClickBinding
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)("一键绑定")), 1)
                        ]),
                        _: 1
                      }, 8, ["loading"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_button, {
                    type: "primary",
                    style: {"color":"var(--fcolor) !important","font-size":"12px","border":"1px solid var(--fcolor)"},
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (importVisible.value = true))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('批量导入规格')), 1)
                    ]),
                    _: 1
                  }),
                  (_unref(isJpPurchase)())
                    ? (_openBlock(), _createBlock(UploadSupplier, {
                        key: 2,
                        onUpdateSuccess: refreshTable
                      }, {
                        trigger: _withCtx(() => [
                          (wareHouseType.value != '2' && _unref(isD2C)())
                            ? (_openBlock(), _createBlock(_component_el_button, {
                                key: 0,
                                type: "primary",
                                style: {"color":"var(--fcolor) !important","font-size":"12px","border":"1px solid var(--fcolor)"}
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(t)('批量导入供应商信息')), 1)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(CommonDialog, {
                    visible: importVisible.value,
                    "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => ((importVisible).value = $event)),
                    width: 600,
                    title: _unref(t)('导入'),
                    className: "upload-file-modal",
                    onCancel: _cache[11] || (_cache[11] = () => importVisible.value = false)
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_16, [
                        _createVNode(_component_el_upload, {
                          drag: "",
                          action: "",
                          "before-upload": upload,
                          accept: ".xls,.xlsx"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_17, [
                              (_unref(isD2C)())
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    (file.value)
                                      ? (_openBlock(), _createElementBlock("img", _hoisted_18))
                                      : (_openBlock(), _createElementBlock("img", _hoisted_19))
                                  ], 64))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    (file.value)
                                      ? (_openBlock(), _createElementBlock("img", _hoisted_20))
                                      : (_openBlock(), _createElementBlock("img", _hoisted_21))
                                  ], 64)),
                              _createElementVNode("div", _hoisted_22, _toDisplayString(!file.value ? _unref(t)('上传文件') : (file.value?.size / 1024 > 1024 ? (file.value?.size /
                        1024 /
                        1024).toFixed(2) + 'M'
                        : (file.value?.size / 1024).toFixed(0) + 'KB')), 1)
                            ])
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("a", {
                            href: `https://static-jp.theckb.com/static-asset/client/${_unref(useSite)() === 'ja' ? '一括編集 ファイル' : 'updateCustomerSkuTemplate_' + _unref(useSite)()}.xlsx?v=` + new Date().getTime()
                          }, _toDisplayString(_unref(t)('模板下载2')), 9, _hoisted_24)
                        ]),
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("div", null, _toDisplayString(_unref(t)('注意事项')), 1),
                          _createElementVNode("div", null, _toDisplayString(_unref(t)('1.表格数据最多为1000行，超过请分多个表格导入')), 1),
                          _createElementVNode("div", null, _toDisplayString(_unref(t)('2.仅支持.xlsx、.xls文件，且小于20M')), 1),
                          _createElementVNode("div", null, _toDisplayString(_unref(t)('3.导入成功后将更改客户商品SKU及客户商品规格信息')), 1),
                          _createElementVNode("div", null, _toDisplayString(_unref(t)('4.THE CKB SKU为必填项，客户商品SKU及客户商品规格不填写默认不修改')), 1)
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["visible", "title"]),
                  _createVNode(UploadFailTable, {
                    visible: importErrorVisible.value,
                    "onUpdate:visible": _cache[12] || (_cache[12] = ($event: any) => ((importErrorVisible).value = $event)),
                    list: fileUploadErrorList.value
                  }, null, 8, ["visible", "list"]),
                  (!_unref(isD2C)() && isAmazon.value)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 3,
                        type: "info",
                        loading: _unref(syncLoading),
                        onClick: setSyncProduct
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)("Amazon在庫数更新")), 1)
                        ]),
                        _: 1
                      }, 8, ["loading"]))
                    : _createCommentVNode("", true),
                  (!_unref(isD2C)() && isAmazon.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_26, _toDisplayString(_unref(t)("更新时间")) + "： " + _toDisplayString(_unref(getJapanTime)(syncTime.value)), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_27, [
                  (showCoustomColumnsTipImgVisible.value)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(descCoustomColumnsTipImg, (prop) => {
                        return _createElementVNode("div", {
                          key: prop.key,
                          style: {"position":"relative"}
                        }, [
                          (_unref(lang) === prop.key)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createElementVNode("img", {
                                  onClick: () => closeDescCoustomColumnsTipImg(prop.url),
                                  class: "close-icons-tip-img",
                                  src: "https://static-s.theckb.com/BusinessMarket/Client/close_icon_item.png",
                                  alt: ""
                                }, null, 8, _hoisted_28),
                                _createElementVNode("img", {
                                  style: {"width":"210px","height":"50px"},
                                  alt: "",
                                  src: prop.url
                                }, null, 8, _hoisted_29)
                              ], 64))
                            : _createCommentVNode("", true)
                        ])
                      }), 64))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_tooltip, {
                    effect: "light",
                    placement: "left",
                    ref: (_value, _refs) => {
                      _refs['tooltipRef'] = _value
                      tooltipRef.value = _value
                    }
                  }, {
                    content: _withCtx(() => [
                      _createVNode(DragTableSearch, {
                        productColumns: _unref(isD2C)() ? _unref(d2cProductColumnsFinal) : b2bProductColumnsFinal.value,
                        selectedColumns: _unref(productColumns),
                        onHandleOk: handleOkSelectColumns,
                        onCancel: _cache[13] || (_cache[13] = ($event: any) => (tooltipRef.value.onClose()))
                      }, null, 8, ["productColumns", "selectedColumns"])
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("p", _hoisted_31, [
                          _createVNode(SvgIcon, {
                            name: "sort",
                            style: {"margin-right":"11px","font-size":"20px"}
                          }),
                          _createTextVNode(" " + _toDisplayString(_unref(t)('表格筛选')), 1)
                        ])
                      ])
                    ]),
                    _: 1
                  }, 512),
                  (!_unref(isD2C)())
                    ? (_openBlock(), _createElementBlock("div", _hoisted_32))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_button, {
                    class: "export-color-gray",
                    style: {"font-size":"12px"},
                    type: "primary",
                    loading: exportProductLoading.value,
                    onClick: exportProduct
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_33, [
                        _hoisted_34,
                        _createTextVNode(" " + _toDisplayString(_unref(t)("导出")), 1)
                      ])
                    ]),
                    _: 1
                  }, 8, ["loading"])
                ])
              ]),
              _createElementVNode("div", _hoisted_35, [
                _createVNode(STable, {
                  ref: (_value, _refs) => {
                    _refs['productRef'] = _value
                    productRef.value = _value
                  },
                  api: _unref(getProductList),
                  "page-data": productPageData.value,
                  "onUpdate:page-data": _cache[18] || (_cache[18] = ($event: any) => ((productPageData).value = $event)),
                  columns: _unref(productColumns),
                  key: wareHouseType.value,
                  filterData: isBatchSearch.value ? { ...batchSearchParams.value, ..._unref(pSortForm), wareHouseType: wareHouseType.value } : { ..._unref(pFilterData), wareHouseType: wareHouseType.value },
                  tableConfig: _unref(realProductTableConfig),
                  isImmediatelyExec: false,
                  isClearSelection: false,
                  onSelectionChange: productSelection,
                  maxHeight: "calc( 100vh - 400px)",
                  onSortChange: productSort,
                  onExpandRow: handleExpandRow,
                  showAllExpand: false,
                  paginationConfig: { pageSizes: [10, 20, 30, 50, 100] }
                }, {
                  productMainImg: _withCtx(({ row }) => [
                    (row.productType !== 2)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                          _createVNode(_component_router_link, {
                            to: _unref(useRtfix)('goods', {
                    params: { id: row.productCode ?? 'null' },
                  })
                          }, {
                            default: _withCtx(() => [
                              _createVNode(ShoppingPreview, {
                                image: row.productSkuImg || row.productMainImg || ''
                              }, null, 8, ["image"])
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_37, [
                          _createVNode(ShoppingPreview, {
                            image: row.productSkuImg || row.productMainImg || ''
                          }, null, 8, ["image"])
                        ]))
                  ]),
                  productInfo: _withCtx(({ row }) => [
                    _createElementVNode("div", _hoisted_38, [
                      _createElementVNode("div", _hoisted_39, [
                        _createVNode(ShoppingPreview, {
                          image: row.productSkuImg || row.productMainImg || ''
                        }, null, 8, ["image"])
                      ]),
                      _createElementVNode("div", _hoisted_40, [
                        (
                      (!row?.productType || row?.productType === 1) &&
                      row?.productCode
                    )
                          ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                              _createVNode(_component_el_tooltip, { effect: "light" }, {
                                content: _withCtx(() => [
                                  _createElementVNode("span", null, _toDisplayString(row?.productTitle), 1)
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(AppLink, {
                                    to: _unref(useRtfix)('goods', { params: { id: row?.productCode } }),
                                    target: "_blank",
                                    tag: "a"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_42, _toDisplayString(row?.productTitle), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["to"])
                                ]),
                                _: 2
                              }, 1024)
                            ]))
                          : (_openBlock(), _createBlock(_component_el_tooltip, {
                              key: 1,
                              effect: "light"
                            }, {
                              content: _withCtx(() => [
                                _createElementVNode("span", null, _toDisplayString(row?.productTitle), 1)
                              ]),
                              default: _withCtx(() => [
                                _createElementVNode("p", _hoisted_43, _toDisplayString(row?.productTitle), 1)
                              ]),
                              _: 2
                            }, 1024))
                      ])
                    ]),
                    (row.reservedSaleFlag == 1)
                      ? (_openBlock(), _createBlock(_component_ElTag, {
                          key: 0,
                          type: "warning"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_44
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  ProcessingProductsHeadD2c: _withCtx(() => [
                    _createElementVNode("div", _hoisted_45, [
                      _createTextVNode(_toDisplayString(_unref(t)("处理中1")), 1),
                      (!platformInventoryExpand.value)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "expand-style",
                            onClick: clickPlatformInventoryExpand
                          }, [
                            _hoisted_46,
                            _createElementVNode("span", null, _toDisplayString(_unref(t)('展开1')), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  thirdItemName: _withCtx(({ row }) => [
                    _createVNode(_component_el_tooltip, {
                      effect: "light",
                      placement: "top"
                    }, {
                      content: _withCtx(() => [
                        _createElementVNode("div", null, _toDisplayString(row.thirdItemName), 1)
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_47, _toDisplayString(row.thirdItemName), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  pendingStorage1: _withCtx(({ row }) => [
                    _createVNode(CountryNum, {
                      disabled: wareHouseType.value != '1',
                      all: row?.pendingStorage,
                      jp: row?.pendingStorageJp,
                      cn: row?.pendingStorageCn
                    }, null, 8, ["disabled", "all", "jp", "cn"])
                  ]),
                  expressNum: _withCtx(({ row }) => [
                    _createVNode(CountryNum, {
                      disabled: wareHouseType.value != '1',
                      all: row.expressNum,
                      jp: row?.expressNumJp,
                      cn: row?.expressNumCn
                    }, null, 8, ["disabled", "all", "jp", "cn"])
                  ]),
                  productType: _withCtx(({ row }) => [
                    _createTextVNode(_toDisplayString(_unref(productTypeSnum)[row.productType]), 1)
                  ]),
                  productName: _withCtx(({ row }) => [
                    (
                  (!row?.productType || row?.productType === 1) &&
                  row?.productCode
                )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                          _createVNode(_component_el_tooltip, { effect: "light" }, {
                            content: _withCtx(() => [
                              _createElementVNode("span", null, _toDisplayString(row?.productTitle), 1)
                            ]),
                            default: _withCtx(() => [
                              _createVNode(AppLink, {
                                to: _unref(useRtfix)('goods', { params: { id: row?.productCode } }),
                                target: "_blank"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(row?.productTitle), 1)
                                ]),
                                _: 2
                              }, 1032, ["to"])
                            ]),
                            _: 2
                          }, 1024)
                        ]))
                      : (_openBlock(), _createBlock(_component_el_tooltip, {
                          key: 1,
                          effect: "light"
                        }, {
                          content: _withCtx(() => [
                            _createElementVNode("span", null, _toDisplayString(row?.productTitle), 1)
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("p", _hoisted_49, _toDisplayString(row?.productTitle), 1)
                          ]),
                          _: 2
                        }, 1024))
                  ]),
                  productPropertiesName: _withCtx(({ row }) => [
                    _createVNode(_component_el_tooltip, { effect: "light" }, {
                      content: _withCtx(() => [
                        _createElementVNode("div", _hoisted_50, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((row.productPropertiesName || '').split(';'), (prop) => {
                            return (_openBlock(), _createElementBlock("p", { key: prop }, _toDisplayString(prop.replace(/[+-]?\d+:[+-]?\d+:/, "")), 1))
                          }), 128))
                        ])
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_51, [
                          _createElementVNode("span", null, _toDisplayString(row.productPropertiesName), 1)
                        ])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  specificationTitle: _withCtx(() => [
                    _createVNode(SpecCol, { isTitle: true })
                  ]),
                  specification: _withCtx(({ row }) => [
                    _createVNode(SpecCol, { row: row }, null, 8, ["row"])
                  ]),
                  productSku: _withCtx(({ row }) => [
                    _createElementVNode("div", _hoisted_52, [
                      (row.productType === 3)
                        ? (_openBlock(), _createBlock(_component_el_tooltip, {
                            key: 0,
                            effect: "light"
                          }, {
                            content: _withCtx(() => [
                              _createElementVNode("p", null, _toDisplayString(row.shopProductSku), 1)
                            ]),
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_53, [
                                _createElementVNode("p", _hoisted_54, _toDisplayString(row.shopProductSku), 1),
                                _createVNode(CopyButton, {
                                  text: row.shopProductSku
                                }, null, 8, ["text"])
                              ])
                            ]),
                            _: 2
                          }, 1024))
                        : (_openBlock(), _createBlock(_component_el_tooltip, {
                            key: 1,
                            effect: "light"
                          }, {
                            content: _withCtx(() => [
                              _createElementVNode("p", null, _toDisplayString(row.productSku), 1)
                            ]),
                            default: _withCtx(() => [
                              (row?.shopProductSku && row.purchaseCountry == 'CN')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createVNode(AppLink, {
                                      to: _unref(useRtfix)('ProductInfo', {
                          query: { shopProductSku: row.shopProductSku },
                        })
                          
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_55, [
                                          _createElementVNode("p", _hoisted_56, _toDisplayString(row.productSku), 1)
                                        ])
                                      ]),
                                      _: 2
                                    }, 1032, ["to"]),
                                    _createVNode(CopyButton, {
                                      text: row.productSku
                                    }, null, 8, ["text"])
                                  ], 64))
                                : (_openBlock(), _createElementBlock("div", _hoisted_57, [
                                    _createElementVNode("p", _hoisted_58, _toDisplayString(row.productSku), 1),
                                    _createVNode(CopyButton, {
                                      text: row.productSku
                                    }, null, 8, ["text"])
                                  ]))
                            ]),
                            _: 2
                          }, 1024))
                    ])
                  ]),
                  b2bproductSku: _withCtx(({ row }) => [
                    _createElementVNode("div", _hoisted_59, [
                      (row.productType === 3)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_60, _toDisplayString(row.shopProductSku), 1))
                        : (_openBlock(), _createElementBlock("p", _hoisted_61, _toDisplayString(row.productSku), 1)),
                      _createVNode(CopyButton, {
                        text: row.productType === 3 ? row.shopProductSku : row.productSku
                      }, null, 8, ["text"])
                    ])
                  ]),
                  unitPrice: _withCtx(({ row }) => [
                    (_unref(isJpPurchaseWhite) && row.productType === 3)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_62, "-"))
                      : (row.purchaseCountry === 'JP')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_63, [
                            _createElementVNode("span", null, _toDisplayString(row.jpyPrice ? `${row.jpyPrice}円` : '-'), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_64, _toDisplayString(row?.unitPrice ?? 0) + _toDisplayString(_unref(isJA)() ? _unref(showCurrentUnit)(row.goodsCountry === 'KR') : ''), 1))
                  ]),
                  b2bProductInfo: _withCtx(({ row }) => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((row.productPropertiesName || '').split(';'), (prop) => {
                      return (_openBlock(), _createElementBlock("p", { key: prop }, _toDisplayString(prop.replace(/[+-]?\d+:[+-]?\d+:/, "")), 1))
                    }), 128))
                  ]),
                  skuInfo: _withCtx(({ row }) => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.skuInfo, (value, key) => {
                      return (_openBlock(), _createElementBlock("p", { key: key }, _toDisplayString(skuKeyDist[key]) + "： " + _toDisplayString(value), 1))
                    }), 128))
                  ]),
                  stockPrice: _withCtx(({ row }) => [
                    _createTextVNode(_toDisplayString(row.stockPrice) + " " + _toDisplayString(_unref(t)("元")), 1)
                  ]),
                  commonProduct: _withCtx(() => [
                    _createElementVNode("div", _hoisted_65, [
                      _withDirectives(_createElementVNode("img", {
                        referrerPolicy: "no-referrer",
                        onClick: _cache[14] || (_cache[14] = ($event: any) => (setShowProductRed(true))),
                        src: _imports_4
                      }, null, 512), [
                        [_vShow, !showProductRed.value]
                      ]),
                      _withDirectives(_createElementVNode("img", {
                        referrerPolicy: "no-referrer",
                        onClick: _cache[15] || (_cache[15] = ($event: any) => (setShowProductRed(false))),
                        src: _imports_5
                      }, null, 512), [
                        [_vShow, showProductRed.value]
                      ])
                    ])
                  ]),
                  amazonProduct: _withCtx(() => [
                    _createElementVNode("div", _hoisted_66, [
                      _withDirectives(_createElementVNode("img", {
                        referrerPolicy: "no-referrer",
                        onClick: _cache[16] || (_cache[16] = ($event: any) => (setShowProductBlue(true))),
                        src: _imports_6
                      }, null, 512), [
                        [_vShow, !showProductBlue.value]
                      ]),
                      _withDirectives(_createElementVNode("img", {
                        referrerPolicy: "no-referrer",
                        onClick: _cache[17] || (_cache[17] = ($event: any) => (setShowProductBlue(false))),
                        src: _imports_7
                      }, null, 512), [
                        [_vShow, showProductBlue.value]
                      ])
                    ])
                  ]),
                  pendingStorageHead: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)("处理中")) + " ", 1),
                    _createVNode(_component_el_tooltip, {
                      placement: "top",
                      effect: "light",
                      "hide-after": 30
                    }, {
                      content: _withCtx(() => [
                        _createElementVNode("div", _hoisted_67, _toDisplayString(_unref(t)("处理中")) + "＝" + _toDisplayString(_unref(t)("待采购")) + "＋" + _toDisplayString(_unref(t)("采购中")) + "＋" + _toDisplayString(_unref(t)("已采购")) + "＋" + _toDisplayString(_unref(t)("国内运输中")) + "＋" + _toDisplayString(_unref(t)("已入库")) + "＋" + _toDisplayString(_unref(t)("检品中")) + "＋" + _toDisplayString(_unref(t)('处理缺陷/异常')), 1)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_el_icon, { color: "#999" }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(QuestionFilled))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  waitPurchaseNumHead: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)("等待采购")), 1)
                  ]),
                  waitPurchaseNum: _withCtx(({ row }) => [
                    _createElementVNode("div", null, _toDisplayString(row.waitPurchaseNum > 0 ? row.waitPurchaseNum : 0), 1)
                  ]),
                  purchasingNumHead: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)("采购处理中")), 1)
                  ]),
                  purchasingNum: _withCtx(({ row }) => [
                    _createElementVNode("div", null, _toDisplayString(row.purchasingNum > 0 ? row.purchasingNum : 0), 1)
                  ]),
                  purchasedNumHead: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)("采购完成")), 1)
                  ]),
                  purchasedNum: _withCtx(({ row }) => [
                    _createElementVNode("div", null, _toDisplayString(row.purchasedNum > 0 ? row.purchasedNum : 0), 1)
                  ]),
                  expressNumHead: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)("国内运输中1")), 1)
                  ]),
                  putInStorageNumHead: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)("已入库1")), 1)
                  ]),
                  checkingNumHead: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)("质检中1")), 1)
                  ]),
                  exceptionNumHead: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)("异常处理中")), 1)
                  ]),
                  pendingStorageHeadD2c: _withCtx(() => [
                    _createElementVNode("div", _hoisted_68, [
                      _createTextVNode(_toDisplayString(_unref(t)("处理中明细")) + " ", 1),
                      (platformInventoryExpand.value)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "expand-style",
                            style: {"top":"-5px"},
                            onClick: clickPlatformInventoryExpand
                          }, [
                            _hoisted_69,
                            _createElementVNode("span", null, _toDisplayString(_unref(t)('收起')), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  pendingStorage: _withCtx(({ row }) => [
                    (row?.pendingStorage)
                      ? (_openBlock(), _createBlock(_component_el_tooltip, {
                          key: 0,
                          placement: "top"
                        }, {
                          content: _withCtx(() => [
                            _createElementVNode("div", _hoisted_70, [
                              _createElementVNode("span", _hoisted_71, _toDisplayString(_unref(t)("处理中")) + "(" + _toDisplayString(_unref(t)('待采购')) + "+" + _toDisplayString(_unref(t)('采购中')) + "+" + _toDisplayString(_unref(t)('已采购')) + "+" + _toDisplayString(_unref(t)('国内运输中')) + "+" + _toDisplayString(_unref(t)('已入库')) + "+" + _toDisplayString(_unref(t)('检品中')) + ") ", 1),
                              _createElementVNode("span", null, _toDisplayString(row?.pendingStorage - row?.abnormalQuantity > 0 ? row?.pendingStorage - row?.abnormalQuantity :
                          0), 1)
                            ]),
                            _createElementVNode("div", _hoisted_72, [
                              _hoisted_73,
                              _createElementVNode("span", null, _toDisplayString(row?.abnormalQuantity > 0 ? row?.abnormalQuantity : 0), 1)
                            ])
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("div", null, _toDisplayString(row?.pendingStorage > 0 ? row?.pendingStorage : 0), 1)
                          ]),
                          _: 2
                        }, 1024))
                      : (_openBlock(), _createElementBlock("div", _hoisted_74, "0"))
                  ]),
                  pendingStorageSlot: _withCtx(({ row }) => [
                    _createTextVNode(_toDisplayString(row.pendingStorage > 0 ? row.pendingStorage : 0), 1)
                  ]),
                  lockQuantityHead: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)("已锁定")) + " ", 1),
                    _createVNode(HeaderTips, {
                      content: _unref(t)('已使用准备发给您的商品')
                    }, null, 8, ["content"])
                  ]),
                  lockQuantityHeadD2c: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)("已锁定")) + " ", 1),
                    _createVNode(HeaderTips, {
                      content: _unref(t)('已使用准备发给您的商品')
                    }, null, 8, ["content"])
                  ]),
                  lockQuantity: _withCtx(({ row }) => [
                    _createVNode(CountryNum, {
                      disabled: wareHouseType.value != '1',
                      all: row.freezeQuantity || row.lockQuantity || 0,
                      jp: row?.lockQuantityJp,
                      cn: row?.lockQuantityCn
                    }, null, 8, ["disabled", "all", "jp", "cn"])
                  ]),
                  platformInventory: _withCtx(() => [
                    _createElementVNode("div", _hoisted_75, [
                      _createTextVNode(_toDisplayString(_unref(t)('平台库存')) + " ", 1),
                      (!platformInventoryExpand.value)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "expand-style",
                            onClick: clickPlatformInventoryExpand
                          }, [
                            _hoisted_76,
                            _createElementVNode("span", null, _toDisplayString(_unref(t)('展开1')), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: "expand-style",
                            onClick: clickPlatformInventoryExpand
                          }, [
                            _hoisted_77,
                            _createElementVNode("span", null, _toDisplayString(_unref(t)('收起')), 1)
                          ]))
                    ])
                  ]),
                  availableQuantityHead: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)("可用库存")) + " ", 1),
                    _createVNode(HeaderTips, {
                      content: _unref(t)('可使用的正品数量')
                    }, null, 8, ["content"])
                  ]),
                  availableQuantityHeadD2c: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)("可用库存")) + " ", 1),
                    _createVNode(HeaderTips, {
                      content: _unref(t)('可使用的正品数量')
                    }, null, 8, ["content"])
                  ]),
                  availableQuantity: _withCtx(({ row }) => [
                    _createVNode(CountryNum, {
                      disabled: wareHouseType.value != '1',
                      all: row.availableQuantity,
                      jp: row?.availableQuantityJp,
                      cn: row?.availableQuantityCn
                    }, null, 8, ["disabled", "all", "jp", "cn"])
                  ]),
                  exceptionNum: _withCtx(({ row }) => [
                    _createVNode(CountryNum, {
                      disabled: wareHouseType.value != '1',
                      all: row.exceptionNum,
                      jp: row?.exceptionNumJp,
                      cn: row?.exceptionNumCn
                    }, null, 8, ["disabled", "all", "jp", "cn"])
                  ]),
                  unableProcessDefectiveProductsHead: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)("次品")) + " ", 1),
                    _createVNode(HeaderTips, {
                      content: _unref(t)('归属为客户的次品')
                    }, null, 8, ["content"])
                  ]),
                  inventoryHead: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)("库龄")) + " ", 1),
                    _createVNode(_component_el_tooltip, {
                      placement: "top",
                      effect: "light",
                      "hide-after": 30
                    }, {
                      content: _withCtx(() => [
                        _createElementVNode("div", _hoisted_78, [
                          _createElementVNode("div", null, _toDisplayString(_unref(t)("在庫の保管日数では、在庫あり商品の保管日数を示します")), 1),
                          _createElementVNode("div", null, _toDisplayString(_unref(t)("在庫の保管日数に含まれる商品 = 良品 + 返品不可不良品")), 1),
                          _createElementVNode("div", null, _toDisplayString(_unref(t)("※在庫保管日数は日単位で計算され、1日未満の場合は1日となります")), 1)
                        ])
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_el_icon, { color: "#999" }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(QuestionFilled))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  unableProcessDefectiveProductsHeadD2c: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)("待处理次品数")) + " ", 1),
                    _createVNode(HeaderTips, {
                      content: _unref(t)('仓库发现商品次品且无法退款，进入您的次品库存')
                    }, null, 8, ["content"])
                  ]),
                  unableProcessDefectiveProducts: _withCtx(({ row }) => [
                    (row.orderProcess)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                          _createVNode(_component_el_popover, {
                            placement: "right-start",
                            width: 250,
                            trigger: "hover",
                            effect: "dark",
                            "hide-after": "1000",
                            "popper-style": "opacity: 0.8"
                          }, {
                            reference: _withCtx(() => [
                              _createElementVNode("span", null, _toDisplayString(row?.unableProcessDefectiveProducts ?? 0), 1)
                            ]),
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_80, [
                                _createElementVNode("div", _hoisted_81, [
                                  _createElementVNode("span", null, _toDisplayString(_unref(t)("未处理")) + ":", 1),
                                  _createElementVNode("span", null, _toDisplayString(row.orderProcess?.unprocessed ?? 0), 1)
                                ]),
                                _createElementVNode("div", _hoisted_82, [
                                  _createElementVNode("span", null, _toDisplayString(_unref(t)("处理中(转正品)")) + ":", 1),
                                  _hoisted_83,
                                  _createElementVNode("span", null, _toDisplayString(row.orderProcess?.process ?? 0), 1)
                                ]),
                                _createElementVNode("div", _hoisted_84, [
                                  _createElementVNode("span", null, _toDisplayString(_unref(t)("已作废")) + ":", 1),
                                  _createElementVNode("span", null, _toDisplayString(row.orderProcess?.haveBecomeObsolete
                        ??
                        0), 1)
                                ]),
                                _createElementVNode("div", _hoisted_85, [
                                  _createElementVNode("span", null, _toDisplayString(_unref(t)("已转正品")) + ":", 1),
                                  _createElementVNode("span", null, _toDisplayString(row.orderProcess?.transferredProduct
                        ??
                        0), 1)
                                ])
                              ])
                            ]),
                            _: 2
                          }, 1024)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_86, _toDisplayString(row?.unableProcessDefectiveProducts ?? 0), 1))
                  ]),
                  amazonProductTitle: _withCtx(({ row }) => [
                    _createVNode(_component_el_tooltip, {
                      effect: "light",
                      placement: "top"
                    }, {
                      content: _withCtx(() => [
                        _createElementVNode("span", null, _toDisplayString(row.amazonProductTitle), 1)
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_87, _toDisplayString(row.amazonProductTitle), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  amazonMsku: _withCtx(({ row }) => [
                    _createVNode(_component_el_tooltip, {
                      effect: "light",
                      placement: "top"
                    }, {
                      content: _withCtx(() => [
                        _createElementVNode("span", null, _toDisplayString(row.amazonMsku), 1)
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_88, _toDisplayString(row.amazonMsku), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  overseaProducSku: _withCtx(({ row }) => [
                    (row.amazonBindStatus === 2)
                      ? (_openBlock(), _createBlock(_component_el_tooltip, {
                          key: 0,
                          effect: "light",
                          placement: "top"
                        }, {
                          content: _withCtx(() => [
                            _createElementVNode("span", null, _toDisplayString(row.thirdProductSku ?? "") + "(" + _toDisplayString(row.amazonFnsku ?? "") + ")", 1)
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_89, _toDisplayString(row.thirdProductSku ?? "") + "(" + _toDisplayString(row.amazonFnsku ?? "") + ")", 1)
                          ]),
                          _: 2
                        }, 1024))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          row
                            ? (_openBlock(), _createBlock(OverseaProductSku, {
                                key: 0,
                                row: row
                              }, null, 8, ["row"]))
                            : _createCommentVNode("", true)
                        ], 64))
                  ]),
                  customerProductMsku: _withCtx(({ row }) => [
                    row
                      ? (_openBlock(), _createBlock(CustomerProductMsku, {
                          key: 0,
                          row: row
                        }, null, 8, ["row"]))
                      : _createCommentVNode("", true)
                  ]),
                  customSupplierName: _withCtx(({ row }) => [
                    row
                      ? (_openBlock(), _createBlock(CustomSupplierName, {
                          key: 0,
                          row: row
                        }, null, 8, ["row"]))
                      : _createCommentVNode("", true)
                  ]),
                  goodsCountry: _withCtx(({ row }) => [
                    _createElementVNode("div", null, _toDisplayString(Enum_country[row.goodsCountry]), 1)
                  ]),
                  purchaseCountry: _withCtx(({ row }) => [
                    (row.productType != 3)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_90, _toDisplayString(Enum_country[row.purchaseCountry]), 1))
                      : _createCommentVNode("", true)
                  ]),
                  handlerHead: _withCtx(() => [
                    _createElementVNode("div", _hoisted_91, [
                      _createElementVNode("p", null, _toDisplayString(_unref(t)("操作")), 1)
                    ])
                  ]),
                  inventory: _withCtx(({ row }) => [
                    _createElementVNode("div", _hoisted_92, [
                      _createElementVNode("div", _hoisted_93, [
                        _createElementVNode("span", _hoisted_94, "0-60" + _toDisplayString(_unref(t)('日')) + ":" + _toDisplayString(row.monthlyStatisticsAgeRespDTO?.firstMonthNum + row.monthlyStatisticsAgeRespDTO?.secondMonthNum), 1),
                        _hoisted_95
                      ]),
                      _createVNode(_component_el_tooltip, {
                        placement: "top",
                        effect: "light",
                        "popper-class": "inventoryPopper"
                      }, {
                        content: _withCtx(() => [
                          _createElementVNode("div", _hoisted_96, _toDisplayString(_unref(t)('库龄')), 1),
                          _createVNode(_component_el_tree, {
                            class: "inventory-tree",
                            data: [
                        {
                          label: '0-60' + _unref(t)('日'),
                          border: false,
                          treeFather: true,
                          children: [
                            {
                              label: '0-30' + _unref(t)('日'),
                              num: row.monthlyStatisticsAgeRespDTO?.firstMonthNum
                            },
                            {
                              label: `31${_unref(t)('日')}-60${_unref(t)('日')}`,
                              num: row.monthlyStatisticsAgeRespDTO?.secondMonthNum
                            }
                          ],
                        },
                        {
                          label: '61-180' + _unref(t)('日'),
                          border: true,
                          treeFather: true,
                          children: [
                            {
                              label: `61${_unref(t)('日')}-120${_unref(t)('日')}`,
                              num: row.monthlyStatisticsAgeRespDTO?.thirdTo4thMonthNum
                            },
                            {
                              label: `121${_unref(t)('日')}-180${_unref(t)('日')}`,
                              num: row.monthlyStatisticsAgeRespDTO?.fiveTo6thMonthNum
                            }
                          ],
                        },
                        {
                          label: '181-365',
                          border: true,
                          treeFather: true,
                          children: [
                            {
                              label: `181${_unref(t)('日')}-240${_unref(t)('日')}`,
                              num: row.monthlyStatisticsAgeRespDTO?.sevenTo8thMonthNum
                            },
                            {
                              label: `241${_unref(t)('日')}-365${_unref(t)('日')}`,
                              num: row.monthlyStatisticsAgeRespDTO?.nineTo12thMonthNum
                            }
                          ],
                        },
                        {
                          label: _unref(t)('365日以上'),
                          border: true,
                          treeFather: true,
                          num: row.monthlyStatisticsAgeRespDTO?.moreThanOneYearNum
                        }
                      ]
                          }, {
                            default: _withCtx(({ node, data }) => [
                              _createElementVNode("div", {
                                class: _normalizeClass(`custom-tree-node flex-ter-bwn ${data.treeFather ? 'treeFather' : ''} ${data.border ? 'treeBorder' : ''}`)
                              }, [
                                _createElementVNode("span", null, _toDisplayString(node.label), 1),
                                _createElementVNode("span", null, _toDisplayString(data.children ? data.children.reduce((target, val) => {
                                return target + val.num
                              }, 0) : data.num) + _toDisplayString(_unref(t)('件')), 1)
                              ], 2)
                            ]),
                            _: 2
                          }, 1032, ["data"])
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_97, _toDisplayString(_unref(t)('详情')) + ">", 1)
                        ]),
                        _: 2
                      }, 1024)
                    ])
                  ]),
                  handler: _withCtx(({ scope }) => [
                    _createElementVNode("div", _hoisted_98, [
                      (_unref(isD2C)())
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createVNode(TableButton, {
                              title: _unref(t)('加入购物车'),
                              loading: scope.row.productAddLoading,
                              onClick: ($event: any) => (productAddSingleCart(scope.row))
                            }, null, 8, ["title", "loading", "onClick"]),
                            _createVNode(_component_el_tooltip, {
                              effect: "light",
                              "popper-class": "btn-none-border-stock"
                            }, {
                              content: _withCtx(() => [
                                _createVNode(TableButton, {
                                  style: {"height":"34px"},
                                  title: _unref(t)('操作日志'),
                                  onClick: ($event: any) => (openOptLog(scope.row))
                                }, null, 8, ["title", "onClick"]),
                                (_unref(isJA)() && scope.row.needCombination)
                                  ? (_openBlock(), _createBlock(TableButton, {
                                      key: 0,
                                      style: {"height":"34px"},
                                      title: _unref(t)('组合商品2'),
                                      onClick: ($event: any) => (comboProduct(scope.row))
                                    }, null, 8, ["title", "onClick"]))
                                  : _createCommentVNode("", true),
                                _createVNode(memberEventBox, {
                                  icon: "member_coin",
                                  "listen-variable": scope.row
                                }, {
                                  default: _withCtx(() => [
                                    (scope.row.thirdSkuCode)
                                      ? (_openBlock(), _createBlock(TableButton, {
                                          key: 0,
                                          style: {"height":"34px"},
                                          title: _unref(t)('关联商品'),
                                          onClick: ($event: any) => (createAssociated(scope.row))
                                        }, null, 8, ["title", "onClick"]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 2
                                }, 1032, ["listen-variable"]),
                                _createVNode(memberEventBox, {
                                  icon: "member_coin",
                                  "listen-variable": scope.row
                                }, {
                                  default: _withCtx(() => [
                                    (!scope.row.thirdSkuCode)
                                      ? (_openBlock(), _createBlock(TableButton, {
                                          key: 0,
                                          style: {"height":"34px"},
                                          title: _unref(t)('去绑定'),
                                          onClick: ($event: any) => (createAssociated(scope.row))
                                        }, null, 8, ["title", "onClick"]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 2
                                }, 1032, ["listen-variable"]),
                                (scope.row.unableProcessDefectiveProducts > 0)
                                  ? (_openBlock(), _createBlock(TableButton, {
                                      key: 1,
                                      style: {"height":"34px"},
                                      title: _unref(t)('次品处理'),
                                      onClick: ($event: any) => (orderHandle(scope.row))
                                    }, null, 8, ["title", "onClick"]))
                                  : _createCommentVNode("", true)
                              ]),
                              default: _withCtx(() => [
                                _createElementVNode("button", _hoisted_99, [
                                  _createElementVNode("span", _hoisted_100, _toDisplayString(_unref(t)('更多')) + ">", 1)
                                ])
                              ]),
                              _: 2
                            }, 1024)
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createVNode(TableButton, {
                              title: _unref(t)('加入购物车'),
                              loading: scope.row.productAddLoading,
                              onClick: ($event: any) => (productAddSingleCart(scope.row))
                            }, null, 8, ["title", "loading", "onClick"]),
                            _createVNode(_component_el_tooltip, {
                              effect: "light",
                              "popper-class": "btn-none-border-stock"
                            }, {
                              content: _withCtx(() => [
                                _createVNode(TableButton, {
                                  title: _unref(t)('操作日志'),
                                  onClick: ($event: any) => (openOptLog(scope.row))
                                }, null, 8, ["title", "onClick"]),
                                (isAmazon.value || _unref(isCrossMall))
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      (scope.row.amazonBindStatus == 2 || scope.row.crossMallBindStatus === 2)
                                        ? (_openBlock(), _createBlock(TableButton, {
                                            key: 0,
                                            title: _unref(t)('修改绑定'),
                                            onClick: ($event: any) => (openBindAmazon(scope.row))
                                          }, null, 8, ["title", "onClick"]))
                                        : (_openBlock(), _createBlock(TableButton, {
                                            key: 1,
                                            title: _unref(t)('去绑定'),
                                            onClick: ($event: any) => (openBindAmazon(scope.row))
                                          }, null, 8, ["title", "onClick"]))
                                    ], 64))
                                  : _createCommentVNode("", true),
                                _createVNode(TableButton, {
                                  title: _unref(t)('详情'),
                                  onClick: ($event: any) => (
                          _ctx.$router.push(
                            _unref(useRtfix)('ProductInfo', {
                              query: { shopProductSku: scope.row.shopProductSku },
                            })
                          )
                          )
                                }, null, 8, ["title", "onClick"]),
                                (scope.row.unableProcessDefectiveProducts > 0)
                                  ? (_openBlock(), _createBlock(TableButton, {
                                      key: 1,
                                      title: _unref(t)('次品处理'),
                                      onClick: ($event: any) => (orderHandle(scope.row))
                                    }, null, 8, ["title", "onClick"]))
                                  : _createCommentVNode("", true)
                              ]),
                              default: _withCtx(() => [
                                _createElementVNode("button", _hoisted_101, [
                                  _createElementVNode("span", _hoisted_102, _toDisplayString(_unref(t)('更多')) + ">", 1)
                                ])
                              ]),
                              _: 2
                            }, 1024)
                          ], 64))
                    ])
                  ]),
                  amazonPredictTotalQuantity: _withCtx(({ row }) => [
                    _createElementVNode("div", null, _toDisplayString(row.amazonPredictTotalQuantity > 0 ? row.amazonPredictTotalQuantity : 0), 1)
                  ]),
                  amazonPredictTotalQuantityTitle: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)("合計")) + " ", 1),
                    _createVNode(_component_el_tooltip, {
                      placement: "top",
                      effect: "light",
                      "hide-after": 30,
                      style: {"margin-top":"4px"}
                    }, {
                      content: _withCtx(() => [
                        (_unref(isJA)())
                          ? (_openBlock(), _createElementBlock("div", _hoisted_103, [
                              (!_unref(isD2C)())
                                ? (_openBlock(), _createElementBlock("span", _hoisted_104, _hoisted_107))
                                : _createCommentVNode("", true),
                              _createTextVNode(" " + _toDisplayString(_unref(t)("合計")) + " = " + _toDisplayString(_unref(t)('平台库存（处理中）')) + "+ " + _toDisplayString(_unref(t)('平台库存（已锁定）')) + " + " + _toDisplayString(_unref(t)('平台库存（可用库存）')) + " + " + _toDisplayString(_unref(t)('平台库存（待处理次品数）')) + " ", 1),
                              _hoisted_108,
                              (!_unref(isD2C)())
                                ? (_openBlock(), _createElementBlock("span", _hoisted_109, [
                                    _hoisted_110,
                                    _hoisted_111,
                                    _createTextVNode(" " + _toDisplayString(_unref(t)("合計")) + " = " + _toDisplayString(_unref(t)('平台库存（处理中）')) + "+ " + _toDisplayString(_unref(t)('平台库存（已锁定）')) + " + " + _toDisplayString(_unref(t)('平台库存（可用库存）')) + " + " + _toDisplayString(_unref(t)('平台库存（待处理次品数）')) + "+ " + _toDisplayString(_unref(t)('AMAZON库存(可售)')) + " + " + _toDisplayString(_unref(t)('AMAZON库存(入库)')), 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        (_unref(isKO)())
                          ? (_openBlock(), _createElementBlock("div", _hoisted_112, [
                              _createTextVNode(_toDisplayString(_unref(t)("合計")) + " = " + _toDisplayString(_unref(t)('平台库存（处理中）')) + "+ " + _toDisplayString(_unref(t)('平台库存（已锁定）')) + " + " + _toDisplayString(_unref(t)('平台库存（可用库存）')) + " + " + _toDisplayString(_unref(t)('平台库存（待处理次品数）')) + " ", 1),
                              _hoisted_113
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      default: _withCtx(() => [
                        (_unref(isKO)() || _unref(isJA)())
                          ? (_openBlock(), _createBlock(_component_el_icon, {
                              key: 0,
                              color: "#999"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(QuestionFilled))
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  volumeHead: _withCtx(() => [
                    _createVNode(VolumeHead)
                  ]),
                  crossMallProductCode: _withCtx(({ row }) => [
                    _createVNode(_component_el_tooltip, {
                      effect: "light",
                      placement: "top"
                    }, {
                      content: _withCtx(() => [
                        _createElementVNode("div", null, _toDisplayString(row.crossMallProductCode), 1)
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_114, _toDisplayString(row.crossMallProductCode), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  crossMallProductSku: _withCtx(({ row }) => [
                    _createVNode(_component_el_tooltip, {
                      effect: "light",
                      placement: "top"
                    }, {
                      content: _withCtx(() => [
                        _createElementVNode("div", null, _toDisplayString(row.crossMallProductSku), 1)
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_115, _toDisplayString(row.crossMallProductSku), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  crossMallProductTitle: _withCtx(({ row }) => [
                    _createVNode(_component_el_tooltip, {
                      effect: "light",
                      placement: "top"
                    }, {
                      content: _withCtx(() => [
                        _createElementVNode("div", null, _toDisplayString(row.crossMallProductTitle), 1)
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_116, _toDisplayString(row.crossMallProductTitle), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  crossMallProp1: _withCtx(({ row }) => [
                    _createVNode(_component_el_tooltip, {
                      effect: "light",
                      placement: "top"
                    }, {
                      content: _withCtx(() => [
                        _createElementVNode("div", null, _toDisplayString(row.crossMallProp1), 1)
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_117, _toDisplayString(row.crossMallProp1), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  crossMallProp2: _withCtx(({ row }) => [
                    _createVNode(_component_el_tooltip, {
                      effect: "light",
                      placement: "top"
                    }, {
                      content: _withCtx(() => [
                        _createElementVNode("div", null, _toDisplayString(row.crossMallProp2), 1)
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_118, _toDisplayString(row.crossMallProp2), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  crossMallProductProp: _withCtx(({ row }) => [
                    _createVNode(_component_el_tooltip, {
                      effect: "light",
                      placement: "top"
                    }, {
                      content: _withCtx(() => [
                        _createElementVNode("div", null, _toDisplayString(row.crossMallProductProp), 1)
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_119, _toDisplayString(row.crossMallProductProp), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  expand: _withCtx(({ scope }) => [
                    _withDirectives(_createElementVNode("div", {
                      class: "table-combine",
                      style: _normalizeStyle({ width: tableWidth.value + 'px' })
                    }, [
                      _createVNode(STable, {
                        "table-data": scope.row.combinationProductItemList,
                        columns: _unref(combinationColumns),
                        showPagination: false,
                        tableConfig: _unref(groupTableConfig)
                      }, {
                        productInfo: _withCtx(({ row }) => [
                          _createElementVNode("div", _hoisted_120, [
                            _createElementVNode("img", {
                              src: row.productSkuImg,
                              alt: "",
                              style: {"width":"46px"}
                            }, null, 8, _hoisted_121),
                            _createVNode(_component_el_tooltip, {
                              effect: "light",
                              placement: "top"
                            }, {
                              content: _withCtx(() => [
                                _createElementVNode("span", null, _toDisplayString(row.productTitle), 1)
                              ]),
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_122, _toDisplayString(row.productTitle), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ])
                        ]),
                        productSkuImg: _withCtx(({ row }) => [
                          _createElementVNode("div", null, [
                            _createElementVNode("img", {
                              src: row.productSkuImg,
                              alt: "",
                              style: {"width":"46px"}
                            }, null, 8, _hoisted_123)
                          ])
                        ]),
                        purchaseCountry: _withCtx(({ row }) => [
                          _createElementVNode("div", null, _toDisplayString(Enum_country[row.purchaseCountry]), 1)
                        ]),
                        productTitle: _withCtx(({ row }) => [
                          _createVNode(_component_el_tooltip, {
                            effect: "light",
                            placement: "top"
                          }, {
                            content: _withCtx(() => [
                              _createElementVNode("span", null, _toDisplayString(row.productTitle), 1)
                            ]),
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_124, _toDisplayString(row.productTitle), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        productSku: _withCtx(({ row }) => [
                          _createVNode(_component_el_tooltip, {
                            effect: "light",
                            placement: "top"
                          }, {
                            content: _withCtx(() => [
                              _createElementVNode("span", null, _toDisplayString(row.productSku), 1)
                            ]),
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_125, _toDisplayString(row.productSku), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        productPropertiesName: _withCtx(({ row }) => [
                          ((row.productPropertiesName || '').replace(/[+-]?\d+:[+-]?\d+:/ig, ''))
                            ? (_openBlock(), _createBlock(_component_el_tooltip, {
                                key: 0,
                                effect: "light",
                                placement: "top"
                              }, {
                                content: _withCtx(() => [
                                  _createElementVNode("span", null, _toDisplayString(row.productPropertiesName.replace(/[+-]?\d+:[+-]?\d+:/ig, '')), 1)
                                ]),
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_126, _toDisplayString(row.productPropertiesName.replace(/[+-]?\d+:[+-]?\d+:/ig, '')), 1)
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true)
                        ]),
                        specificationTitle: _withCtx(() => [
                          _createVNode(SpecCol, { isTitle: true })
                        ]),
                        specification: _withCtx(({ row }) => [
                          _createVNode(SpecCol, { row: row }, null, 8, ["row"])
                        ]),
                        productSellPrice: _withCtx(({ row }) => [
                          (row.purchaseCountry === 'JP' && _unref(isJpPurchaseWhite))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_127, _toDisplayString(row.productSellPriceJP ??
                        row.productSellPrice) + "円", 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_128, [
                                _createTextVNode(_toDisplayString(row.productSellPrice) + " ", 1),
                                _createElementVNode("span", null, _toDisplayString(_unref(isJA)() ? _unref(showCurrentUnit)(row.goodsCountry === 'KR') : ''), 1)
                              ]))
                        ]),
                        remainCombinationProductItemRespList: _withCtx(({ row }) => [
                          _createTextVNode(_toDisplayString((row.remainCombinationProductItemRespList || []).reduce((total, v): number => {
                        return total + v.remainCombinationQuantity
                      }, 0)), 1)
                        ]),
                        _: 2
                      }, 1032, ["table-data", "columns", "tableConfig"])
                    ], 4), [
                      [_directive_loading, scope.row.loading]
                    ])
                  ]),
                  _: 1
                }, 8, ["api", "page-data", "columns", "filterData", "tableConfig"])
              ])
            ])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_tab_pane, {
          label: _unref(t)('我的物料'),
          name: "materials"
        }, {
          default: _withCtx(() => [
            _createVNode(STable, {
              key: wareHouseType.value,
              ref: (_value, _refs) => {
                _refs['materialsRef'] = _value
                materialsRef.value = _value
              },
              api: _unref(getStockList),
              "page-data": materialsPageData.value,
              "onUpdate:page-data": _cache[21] || (_cache[21] = ($event: any) => ((materialsPageData).value = $event)),
              columns: _unref(calMaterialsColumns),
              filterData: isBatchSearch.value ? { ...batchSearchParams.value, ..._unref(mSortForm), wareHouseType: wareHouseType.value } : { ..._unref(mFilterData), wareHouseType: wareHouseType.value },
              isImmediatelyExec: false,
              tableConfig: _unref(materialsTableConfig),
              onDataListener: dataListener,
              onSelectionChange: materialSelection,
              onSortChange: materialsSort,
              pageSizes: [10, 20, 30, 500]
            }, {
              ingredientsImg: _withCtx(({ row }) => [
                _createElementVNode("div", _hoisted_129, [
                  _createVNode(ShoppingPreview, {
                    image: row.ingredientsImg
                  }, null, 8, ["image"])
                ])
              ]),
              relatedFlag: _withCtx(({ row }) => [
                (row.relatedFlag)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_130, _toDisplayString(_unref(t)("已关联")), 1))
                  : (_openBlock(), _createElementBlock("p", _hoisted_131, [
                      _createTextVNode(_toDisplayString(_unref(t)("未关联附加项")) + " ", 1),
                      _createVNode(_component_el_tooltip, {
                        content: _unref(t)('未关联附加项的辅料，将不会再订单商品中自动使用'),
                        placement: "top",
                        effect: "light"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_132
                        ]),
                        _: 1
                      }, 8, ["content"])
                    ]))
              ]),
              materialsStyle: _withCtx(({ row }) => [
                _createElementVNode("p", null, _toDisplayString(row?.sizeJp ?? "") + ";" + _toDisplayString(row?.colorJp ?? ""), 1)
              ]),
              noStockQuantity: _withCtx(({ row }) => [
                _createTextVNode(_toDisplayString(row.noStockQuantity ?? 0) + _toDisplayString(_unref(t)("件")), 1)
              ]),
              lockQuantity: _withCtx(({ row }) => [
                _createVNode(CountryNum, {
                  disabled: wareHouseType.value != '1',
                  all: row.lockQuantity,
                  jp: row?.lockQuantityJp,
                  cn: row?.lockQuantityCn,
                  unit: _unref(t)('件')
                }, null, 8, ["disabled", "all", "jp", "cn", "unit"])
              ]),
              availableQuantityHead: _withCtx(() => [
                _createElementVNode("span", _hoisted_133, _toDisplayString(_unref(t)("可用库存")), 1)
              ]),
              availableQuantity: _withCtx(({ row }) => [
                _createVNode(CountryNum, {
                  disabled: wareHouseType.value != '1',
                  all: row.availableQuantity,
                  jp: row?.availableQuantityJp,
                  cn: row?.availableQuantityCn,
                  unit: _unref(t)('件')
                }, null, 8, ["disabled", "all", "jp", "cn", "unit"])
              ]),
              expressNum: _withCtx(({ row }) => [
                _createVNode(CountryNum, {
                  disabled: wareHouseType.value != '1',
                  all: row.expressNum,
                  jp: row?.expressNumJp,
                  cn: row?.expressNumCn
                }, null, 8, ["disabled", "all", "jp", "cn"])
              ]),
              exceptionNum: _withCtx(({ row }) => [
                _createVNode(CountryNum, {
                  disabled: wareHouseType.value != '1',
                  all: row.exceptionNum,
                  jp: row?.exceptionNumJp,
                  cn: row?.exceptionNumCn
                }, null, 8, ["disabled", "all", "jp", "cn"])
              ]),
              notice: _withCtx(({ row, column }) => [
                _createVNode(_component_el_switch, {
                  "model-value": row.earlyWarningFlag > 0,
                  "before-change": column.event.bind(null, row, row.earlyWarningFlag)
                }, null, 8, ["model-value", "before-change"])
              ]),
              handler: _withCtx(({ scope }) => [
                (scope.row.uploadFlag)
                  ? (_openBlock(), _createBlock(TableButton, {
                      key: 0,
                      title: _unref(t)('后台导入')
                    }, null, 8, ["title"]))
                  : _createCommentVNode("", true),
                _createVNode(TableButton, {
                  title: _unref(t)('配置附加项'),
                  onClick: _cache[19] || (_cache[19] = ($event: any) => (
              _ctx.$router.push(_unref(useRtfix)('setupShop', { query: { type: 'ShopAddition' } }))
              ))
                }, null, 8, ["title"]),
                (_unref(materialsCanAddCart)(scope.row))
                  ? (_openBlock(), _createBlock(TableButton, {
                      key: 1,
                      title: _unref(t)('加入购物车'),
                      loading: scope.row.materialAddLoading,
                      onClick: ($event: any) => (materialAddSingleCart(scope.row))
                    }, null, 8, ["title", "loading", "onClick"]))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      (scope.row.uploadFlag !== 1)
                        ? (_openBlock(), _createBlock(TableButton, {
                            key: 0,
                            title: _unref(t)('重新寻源'),
                            onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.$router.push(_unref(useRtfix)('oemQuest'))))
                          }, null, 8, ["title"]))
                        : _createCommentVNode("", true)
                    ], 64))
              ]),
              _: 1
            }, 8, ["api", "page-data", "columns", "filterData", "tableConfig"])
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _: 1
    }, 8, ["modelValue", "class"]), [
      [_vShow, perspective.value == '1']
    ]),
    (_unref(shopInfo)?.authStatus === '1' && perspective.value == '2')
      ? (_openBlock(), _createBlock(SalesPerspective, {
          key: 2,
          thirdWhite: thirdWhite.value.includes(_unref(shopInfo).customerId),
          historyWhite: historyWhite.value.includes(_unref(membership).superCustomerId)
        }, null, 8, ["thirdWhite", "historyWhite"]))
      : _createCommentVNode("", true),
    (materialsFlag.value)
      ? (_openBlock(), _createBlock(AccessoriesDialog, {
          key: 3,
          visible: accessoriesVisible.value,
          "onUpdate:visible": _cache[23] || (_cache[23] = ($event: any) => ((accessoriesVisible).value = $event)),
          title: _unref(t)('辅料绑定提醒')
        }, null, 8, ["visible", "title"]))
      : _createCommentVNode("", true),
    _createVNode(_component_el_dialog, {
      modelValue: createTypeVisible.value,
      "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((createTypeVisible).value = $event)),
      "custom-class": "createTypeVisible",
      "destroy-on-close": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_134, _toDisplayString(_unref(t)("配送")), 1),
        _createElementVNode("div", _hoisted_135, [
          (_unref(isMultiStore)())
            ? (_openBlock(), _createElementBlock("div", _hoisted_136, [
                _createElementVNode("span", null, _toDisplayString(_unref(t)('货品仓库')), 1),
                _createVNode(_component_el_select, {
                  modelValue: wareType.value,
                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((wareType).value = $event)),
                  style: {"width":"140px","margin-left":"8px"},
                  class: "selectSku",
                  disabled: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: _unref(t)('中国仓'),
                      value: "CN"
                    }, null, 8, ["label"]),
                    _createVNode(_component_el_option, {
                      label: _unref(t)('韩国仓'),
                      value: "KR"
                    }, null, 8, ["label"])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]))
            : _createCommentVNode("", true),
          (isAmazon.value)
            ? (_openBlock(), _createBlock(_component_el_radio_group, {
                key: 1,
                modelValue: createType.value,
                "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((createType).value = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio, { label: 1 }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)("通过FBA补货计划发货")), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_radio, { label: 2 }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)("普通发货")), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"]))
            : _createCommentVNode("", true),
          (createType.value === 2)
            ? (_openBlock(), _createBlock(_component_el_radio_group, {
                key: 2,
                modelValue: sendType.value,
                "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((sendType).value = $event)),
                style: {"padding":"10px 0"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio, { label: 2 }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('乐天')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_radio, { label: 3 }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('SHOPLIST')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_radio, { label: 4 }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('ZOZOTOWN')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_radio, { label: 0 }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('其他')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"]))
            : _createCommentVNode("", true),
          _createElementVNode("p", _hoisted_137, _toDisplayString(_unref(t)("店铺")) + ": " + _toDisplayString(_unref(customerShopName)), 1),
          _createElementVNode("div", _hoisted_138, [
            _createVNode(_component_el_button, {
              onClick: _cache[27] || (_cache[27] = ($event: any) => (createTypeVisible.value = false))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)("取消")), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: creatShipping
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)("确认")), 1)
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: bindAmazonVisible.value,
      "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((bindAmazonVisible).value = $event)),
      "destroy-on-close": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_139, _toDisplayString(rowItem.value?.amazonBindStatus != 2 ? _unref(t)("绑定") : _unref(t)("换绑")) + _toDisplayString(_unref(t)("Amazon sku")), 1),
        _createElementVNode("div", _hoisted_140, [
          _createElementVNode("div", _hoisted_141, [
            _createElementVNode("p", _hoisted_142, _toDisplayString(_unref(t)("平台")) + " : " + _toDisplayString(_unref(t)("AMAZON")), 1)
          ]),
          _createVNode(BindAmazon, {
            rowItem: rowItem.value,
            "onUpdate:visible": _cache[29] || (_cache[29] = ($event: any) => (bindAmazonVisible.value = false)),
            onSuccess: refreshTable
          }, null, 8, ["rowItem"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (logData.value)
      ? (_openBlock(), _createBlock(_component_el_dialog, {
          key: 4,
          "model-value": true,
          onClosed: _cache[31] || (_cache[31] = ($event: any) => (logData.value = false))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_143, [
              _createElementVNode("div", _hoisted_144, _toDisplayString(_unref(t)('操作日志')), 1),
              _createElementVNode("div", _hoisted_145, _toDisplayString(_unref(t)('商品规格/客户SKU')), 1)
            ]),
            _createElementVNode("div", _hoisted_146, [
              _createVNode(TableLike, {
                data: logData.value,
                style: {"min-height":"300px","border-top":"1px solid #f2f2f2"},
                class: "optlog-table",
                columns: [
          { prop: 'time', label: _unref(t)('时间') },
          { prop: 'scenes', label: _unref(t)('场景') },
          { prop: 'action', label: _unref(t)('明细') }
        ]
              }, null, 8, ["data", "columns"])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(ChooseSendType, {
      visible: sendTypeVisible.value,
      "onUpdate:visible": _cache[32] || (_cache[32] = ($event: any) => ((sendTypeVisible).value = $event)),
      "custom-class": "createTypeVisible",
      onChooseCall: chooseCall
    }, null, 8, ["visible"]),
    (!_unref(isD2C)() && _unref(tabData) !== 'materials')
      ? (_openBlock(), _createBlock(Guide, {
          key: 5,
          name: "b2b-stock-list"
        }))
      : _createCommentVNode("", true),
    (!_unref(isD2C)() && _unref(tabData) === 'materials')
      ? (_openBlock(), _createBlock(Guide, {
          key: 6,
          name: "b2b-materials-list"
        }))
      : _createCommentVNode("", true),
    (_unref(isD2C)())
      ? (_openBlock(), _createBlock(Guide, {
          key: 7,
          name: "d2c-stock-list"
        }))
      : _createCommentVNode("", true),
    _createVNode(BatchSearch, { title: "Stock" }),
    _createVNode(BindAmazonSkuModal, {
      visible: amazonSkuVisible.value,
      "onUpdate:visible": _cache[33] || (_cache[33] = ($event: any) => ((amazonSkuVisible).value = $event)),
      item: rowItem.value,
      onSuccess: refreshTable
    }, null, 8, ["visible", "item"]),
    _createVNode(AdditionWarnSetting, {
      visible: additionWarnVisible.value,
      onClose: _cache[34] || (_cache[34] = ($event: any) => (additionWarnVisible.value = false))
    }, null, 8, ["visible"])
  ], 2))
}
}

})